/* cs-diagnosis — 自転車診断 v7（2026-10-08 作り直し・本間さん依頼）
 *
 * ■ 何を作り直したか（設計の正は docs/plan/BIKE-DIAGNOSIS.md §10）
 *  1. 質問を「接客の順番」に並べ直した。だれが乗るか → 頭にある自転車 → 使い方 → 道の様子 →
 *     置き場所と体 → 予算と決め手 → 好み → いつ乗り始めたいか。
 *     旧版は「付き合い方」「定番か個性か」「いつか走りたい」が重なり、
 *     逆に「坂」「雨」「荷物」「子どもの自転車」「頭にある車種」を聞いていなかった。
 *  2. 理由は「〇〇とお答えだったので → この一台の△△」の形にした（need → reason）。
 *     ひとつの答えが、どの事実に結びついたかを1行ずつ見せる。点数の加算と理由の文は同じ場所で作る
 *     （点数は入ったのに理由が出ない／理由はあるのに点数に効いていない、を作らない）。
 *  3. 結果は「本命・比べる候補・別の選び方・専門ブランド」の役で選ぶ（上位3台ではなく）。
 *     店員が「本命はこれ、予算をおさえるならこれ、もし足せるならこれ」と勧める並び。
 *  4. 結果の最後は来店につなぐ。在庫の店舗名・1か所で見比べられる店舗・店舗で確かめること・
 *     いつ乗り始めたいかに合わせた次の一歩。結果のURLに答えを入れ、店舗で見せられるようにした。
 *
 * ■ 書いてよい文（CLAUDE.md §2・docs/spec/copy-rules.md）
 *  - 事実はデータから（用途タグ・変速・重さの区分・適応身長・ライト・在庫店舗数）。無ければ書かない。
 *  - 商品の紹介文は、商品ページの説明をそのまま使う（cs-diagnosis-text.json・一字も変えない）。
 *  - 理由の後半（「上り坂でモーターが脚の力を補います」）は、その種類の自転車について言える一般の説明だけ。
 *  - 使わない: 安心・必ず・すぐ・いちばん・人気・最適・ぴったり・試乗（試乗車は候補から外す）。
 *
 * ■ ブラウザ以外でも動く
 *  診断の中身（質問・採点・選び方・結果のHTML）は DOM を使わない。末尾で module.exports に出し、
 *  scripts/ops/diagnosis/sim.mjs が同じファイルで10人のペルソナを回す（試した結果と本番をずらさない）。
 */
(function (G) {
  'use strict';

  /* ───────────── 質問 ───────────── */
  var CH = ['だれが乗るか', '思い描いている自転車', '使い方', '置き場所と体', '予算と決め手', '好み', 'これから'];
  var notChild = function (a) { return a.rider !== 'child'; };
  var isChild = function (a) { return a.rider === 'child'; };
  var isCarry = function (a) { return a.rider === 'kidscarry'; };
  var isSelf = function (a) { return a.rider === 'self'; };

  var QUESTIONS = [
    { id: 'rider', ch: 0, q: 'どなたが乗る自転車ですか？', options: [
      { v: 'self', label: 'わたしが乗る' },
      { v: 'kidscarry', label: 'わたしが乗って、子どもを乗せる' },
      { v: 'child', label: '子どもが乗る（子ども用の自転車）' },
    ] },
    /* 頭にある自転車（v7）。客はたいてい何かを思い描いて来る。先に聞いて、結果でそれに答える。
       ずれた提案をするときは「思い描いていたのは〇〇でしたが」と理由を添える（別の選び方の枠）。 */
    { id: 'image', ch: 1, showIf: isSelf, q: 'いま思い描いている自転車に近いのは？', note: '決まっていなくても大丈夫です', options: [
      { v: 'city', label: 'ママチャリ・シティサイクル' },
      { v: 'school', label: '通学用の自転車（中高生・27インチなど）' },
      { v: 'ebike', label: '電動アシスト自転車（ふだん使いの形）' },
      { v: 'esport', label: 'スポーツタイプの電動（e-bike）' },
      { v: 'town', label: 'シンプルでおしゃれな街乗り車' },
      { v: 'cross', label: 'クロスバイク' },
      { v: 'road', label: 'ロードバイク' },
      { v: 'tour', label: '旅や未舗装の道を走る自転車（ツーリング・グラベル）' },
      { v: 'mini', label: '小さめの車輪（ミニベロ・折りたたみ）' },
      { v: 'mtb', label: 'マウンテンバイク' },
      { v: 'undecided', label: 'まだ決めていない' },
    ] },
    /* 価値観（2026-10-09 本間さん「価値観で選ぶ的な要素を少しいれてもよい」・navi-bike の1問目を参考）。
       形や条件では言い表せない「どんな時間にしたいか」。採点は小さく、データで言えるときだけ理由にする */
    { id: 'mood', ch: 1, showIf: isSelf, q: '自転車に乗っている自分を想像すると？', note: '近いものを1つ', options: [
      { v: 'swift', label: '風を切って、すいすい進んでいる', chip: 'すいすい進みたい' },
      { v: 'stroll', label: '景色を眺めながら、のんびり走っている', chip: 'のんびり走りたい' },
      { v: 'sweat', label: '体を動かして、気持ちよく汗をかいている', chip: '体を動かしたい' },
      { v: 'errand', label: '荷物も用事も、まとめて片づけている', chip: '用事を片づけたい' },
      { v: 'roam', label: '知らない道や遠くの町へ、足を延ばしている', chip: '遠くへ行きたい' },
      { v: '', label: '思い浮かばない' },
    ] },
    { id: 'kids_count', ch: 1, showIf: isCarry, q: '何人のお子さんを乗せますか？', options: [
      { v: '1', label: '1人' },
      { v: '2', label: '2人（前とうしろ）' },
      { v: '1+', label: 'いまは1人、いずれ2人' },
    ] },
    { id: 'kids_age', ch: 1, showIf: isCarry, q: '乗せるお子さんの年齢は？', options: [
      { v: 'front', label: '1〜3歳ごろ（前に乗せる年齢）', showIf: function (a) { return a.kids_count !== '2'; } },
      { v: 'rear', label: '3歳〜小学校に入る前', showIf: function (a) { return a.kids_count !== '2'; } },
      { v: 'both', label: '1〜3歳の子と、3歳〜小学校前の子', showIf: function (a) { return a.kids_count === '2'; } },
      { v: 'young2', label: '2人とも3歳まで', showIf: function (a) { return a.kids_count === '2'; } },
      { v: '', label: 'これから生まれる・未定' },
    ] },
    /* 子ども用の自転車（v7 新設）。旧版は大人の質問のまま子ども用を候補から外していた。 */
    { id: 'child_height', ch: 1, showIf: isChild, q: 'お子さんの身長は？', note: 'いまの身長で選びます', options: [
      { v: 'h95', label: '〜100cm（2〜3歳ごろ）' },
      { v: 'h108', label: '100〜115cm（4〜5歳ごろ）' },
      { v: 'h120', label: '115〜125cm（6〜7歳ごろ）' },
      { v: 'h132', label: '125〜140cm（8〜10歳ごろ）' },
      { v: 'h145', label: '140cm〜（高学年）' },
    ] },
    { id: 'child_use', ch: 2, showIf: isChild, q: 'どんなふうに乗りますか？', options: [
      { v: 'first', label: 'はじめての自転車・乗る練習から' },
      { v: 'play', label: '公園や友だちの家へ' },
      { v: 'far', label: '坂のある道や、少し遠くまで' },
    ] },
    /* 乗り方は2つまで（v7 round-2）。「平日は通学、休日は遠出」を1つに決めさせると、まとめがちぐはぐになる */
    { id: 'use', ch: 2, multi: true, max: 2, showIf: isSelf, q: '乗り方は？', note: '多いものから2つまで選べます', options: [
      { v: 'commute', label: '通勤・通学' },
      { v: 'shopping', label: '買い物・ちょっとした用事' },
      { v: 'town', label: '街をぶらぶら・カフェや散策' },
      { v: 'ride', label: '休日に遠くまで走りに行く' },
      { v: 'fitness', label: '運動・体力づくり' },
    ] },
    { id: 'dist', ch: 2, showIf: notChild, q: '1回に走る距離は？（片道）', options: [
      { v: 'short', label: '〜3km（近所）' },
      { v: 'mid', label: '3〜10km' },
      { v: 'long', label: '10km以上' },
      { v: '', label: 'まだ分からない' },
    ] },
    /* 道の様子は複数選択（v7）。坂・夜・雨・荷物は同時に当てはまるのが普通で、
       1つずつ聞くと質問が4つ増える。1画面で「当てはまるものを全部」にした。 */
    { id: 'cond', ch: 2, multi: true, showIf: notChild, q: '走る道や乗り方で、当てはまるものは？', note: '当てはまるものを全部えらんでください', options: [
      { v: 'hill', label: '坂道がある' },
      { v: 'night', label: '暗くなってからも乗る' },
      { v: 'rain', label: '雨の日も乗ることがある' },
      { v: 'load', label: '荷物が多い・重い' },
      { v: 'knee', label: 'またぎやすい低いフレームがいい（膝や腰が気になる）', showIf: isSelf },
      { v: 'skirt', label: 'スカートで乗りたい', showIf: isSelf },
      { v: 'suit', label: 'スーツ・革靴で乗りたい', showIf: isSelf },
      { v: 'tour', label: '荷物を積んで旅もしてみたい', showIf: isSelf },
      { v: 'dirt', label: '砂利道や山道も走りたい', showIf: isSelf },
    ] },
    { id: 'place', ch: 3, showIf: notChild, q: '自転車はどこに置きますか？', options: [
      { v: 'outdoor', label: '屋外の駐輪場・軒先' },
      { v: 'indoor', label: '室内や玄関（運び上げはしない）' },
      { v: 'carry', label: '室内（階段で運び上げる）' },
      { v: 'elev', label: '室内（エレベーターで運ぶ）' },
      { v: 'car', label: '車に積んだり、電車に持ち込んだりしたい', showIf: isSelf },
      { v: '', label: 'まだ決めていない' },
    ] },
    { id: 'height', ch: 3, showIf: notChild, q: '乗る方の身長は？', note: 'サイズの合わない車体は出しません', options: [
      { v: '145', label: '〜150cm' },
      { v: '155', label: '150〜160cm' },
      { v: '165', label: '160〜170cm' },
      { v: '175', label: '170〜180cm' },
      { v: '185', label: '180cm〜' },
      { v: '', label: '答えない' },
    ] },
    /* 行ける店舗のあたり（v7 round-2）。在庫の店舗を近い順に出し、「1か所で見比べられる店舗」を
       行ける範囲から選ぶ。位置情報を許可しない人にも、遠い店舗を先に見せない */
    { id: 'area', ch: 3, q: 'お店に行くなら、どのあたりですか？', note: '在庫のある店舗を、このあたりから近い順に出します', options: [
      { v: 'te', label: '東京23区の東側（上野・浅草・江東・江戸川など）' },
      { v: 'tw', label: '東京23区の西側（渋谷・世田谷・新宿・練馬など）' },
      { v: 'tm', label: '東京の多摩地域（立川・八王子・調布など）' },
      { v: 'kn', label: '神奈川' },
      { v: 'st', label: '埼玉' },
      { v: 'cb', label: '千葉・茨城' },
      { v: 'sz', label: '静岡' },
      { v: '', label: '決めていない' },
    ] },
    { id: 'electric', ch: 4, showIf: function (a) { return notChild(a) && a.image !== 'ebike' && a.image !== 'esport'; }, q: '電動アシストはどうしますか？', options: [
      { v: 'yes', label: '電動アシストにしたい' },
      { v: 'no', label: '電動ではないものがいい' },
      { v: 'unsure', label: '迷っている（重さや充電が気になる）' },
      { v: '', label: 'どちらでも（おすすめにまかせる）' },
    ] },
    { id: 'budget', ch: 4, showIf: notChild, q: 'ご予算は？（税込）', options: [
      { v: 'b3', label: '〜3万円' },
      { v: 'b5', label: '3〜5万円' },
      { v: 'b8', label: '5〜8万円' },
      { v: 'b10', label: '8〜10万円' },
      { v: 'b13', label: '10〜13万円' },
      { v: 'b16', label: '13〜16万円' },
      { v: 'b20', label: '16〜20万円' },
      { v: 'b30', label: '20〜30万円' },
      { v: 'b50', label: '30〜50万円' },
      { v: 'b99', label: '50万円〜' },
      { v: 'q', label: '良いものなら考えたい' },
    ] },
    { id: 'budget', ch: 4, showIf: isChild, q: 'ご予算は？（税込）', options: [
      { v: 'k2', label: '〜2万円' },
      { v: 'k3', label: '2〜3万円台' },
      { v: 'k5', label: '4〜5万円台' },
      { v: 'k6', label: '6万円〜' },
      { v: '', label: '決めていない' },
    ] },
    { id: 'priority', ch: 4, multi: true, max: 2, showIf: notChild, q: '選ぶときに、特に大事にしたいことは？', note: '大事な順に2つまで選べます', options: [
      { v: 'safe', label: '子どもを乗せたときの乗りやすさ', showIf: isCarry },
      { v: 'easy', label: 'ラクに走れること' },
      { v: 'light', label: '軽さ・扱いやすさ' },
      { v: 'price', label: '価格をおさえること' },
      { v: 'tough', label: '丈夫さ・手間の少なさ' },
      { v: 'design', label: '見た目・デザイン' },
      { v: 'speed', label: '速さ・走る楽しさ', showIf: isSelf },
      { v: 'long', label: '長く使えること' },
    ] },
    { id: 'look', ch: 5, showIf: notChild, q: '見た目の好みは？', note: '直感で選んでください', options: [
      { v: 'classic', label: 'クラシック・レトロ' },
      { v: 'modern', label: 'すっきりモダン' },
      { v: 'sporty', label: 'スポーティで速そう' },
      { v: 'natural', label: 'やわらかくナチュラル' },
      { v: 'bold', label: '色や存在感で目を引く' },
      { v: '', label: 'こだわらない' },
    ] },
    { id: 'child_look', ch: 5, showIf: isChild, q: 'お子さんの好きな雰囲気は？', options: [
      { v: 'cool', label: 'かっこいい・スポーティ' },
      { v: 'cute', label: 'かわいい・明るい色' },
      { v: 'simple', label: 'シンプル・きょうだいで使える' },
      { v: '', label: '本人と店舗で決める' },
    ] },
    { id: 'style', ch: 5, showIf: isSelf, q: '自転車とは、どう付き合いたいですか？', options: [
      { v: 'standard', label: 'みんなが乗っている定番で、手間なく', chip: '定番で手間なく' },
      { v: 'long', label: '気に入った一台を、直しながら長く', chip: '直しながら長く' },
      { v: 'unique', label: '人と被らない、個性のある一台', chip: '人と被らない' },
      { v: 'custom', label: '部品を替えて、自分好みに育てたい', chip: '自分好みに育てたい' },
      { v: '', label: 'とくにない' },
    ] },
    { id: 'timing', ch: 6, q: 'いつごろ乗り始めたいですか？', note: '結果のあとの案内が変わります', options: [
      { v: 'soon', label: 'できるだけ早く（2週間以内）' },
      { v: 'month', label: '1か月以内' },
      { v: 'later', label: '急がない・情報を集めている' },
    ] },
  ];

  function optsFor(q, a) {
    return q.options.filter(function (o) { return !o.showIf || o.showIf(a); });
  }
  /* 見えている質問の列（分岐で長さが変わる）。答えを受けて毎回計算し直す */
  function flowFor(a) {
    return QUESTIONS.filter(function (q) { return !q.showIf || q.showIf(a); })
      .map(function (q) { return { id: q.id, ch: q.ch, q: q.q, note: q.note, multi: !!q.multi, max: q.max || 0, options: optsFor(q, a) }; });
  }
  /* 質問を飛ばした答えの補い。「電動アシスト自転車」を思い描いている人に電動かどうかは聞かない */
  var OLD_BUDGET = { b12: 'b13', b35: 'b30' };
  var OLD_HEIGHT = { '158': '155', '170': '165', '180': '175' };
  function normalize(a) {
    var b = {};
    for (var k in a) if (Object.prototype.hasOwnProperty.call(a, k)) b[k] = a[k];
    // 前の版の結果URL（予算・身長の区切りが違った）も開けるように読み替える
    if (OLD_BUDGET[b.budget]) b.budget = OLD_BUDGET[b.budget];
    if (OLD_HEIGHT[b.height]) b.height = OLD_HEIGHT[b.height];
    if (b.uses && !b.use) b.use = b.uses;
    if (b.priorities && !b.priority) b.priority = b.priorities;
    if (typeof b.use === 'string') b.use = b.use ? [b.use] : [];
    if (!Array.isArray(b.use)) b.use = [];
    if (!Array.isArray(b.cond)) b.cond = [];
    // 聞いていない質問の答えは使わない（分岐で見えなかった質問の答えを、理由に書かない）
    var vis = {};
    QUESTIONS.forEach(function (q) { if (!q.showIf || q.showIf(b)) vis[q.id] = 1; });
    KEYS.forEach(function (k2) { if (!vis[k2]) delete b[k2]; });
    if (!Array.isArray(b.cond)) b.cond = [];
    if (!Array.isArray(b.use)) b.use = [];
    b.cond = b.cond.filter(function (c) {
      var q = QUESTIONS.filter(function (x) { return x.id === 'cond'; })[0];
      return optsFor(q, b).some(function (o) { return o.v === c; });
    });
    if (b.image === 'ebike' || b.image === 'esport') b.electric = 'yes';
    // 乗り方は2つまで選べる。uses が全部、use はいちばん多いもの
    if (typeof b.priority === 'string') b.priority = b.priority ? [b.priority] : [];
    if (!Array.isArray(b.priority)) b.priority = [];
    b.priorities = b.priority.slice(0, 2);
    b.priority = b.priorities[0] || '';
    b.uses = b.use.slice(0, 2);
    b.use = b.uses[0] || '';
    return b;
  }
  var has = function (a, c) { return (a.cond || []).indexOf(c) >= 0; };
  var uses = function (a, u) { return (a.uses || []).indexOf(u) >= 0; };

  /* ───────────── 答えの言い換え（結果画面で「〇〇とのことなので」に使う） ───────────── */
  function label(id, v, a) {
    for (var i = 0; i < QUESTIONS.length; i++) {
      var q = QUESTIONS[i];
      if (q.id !== id || (q.showIf && !q.showIf(a))) continue;
      for (var j = 0; j < q.options.length; j++) if (q.options[j].v === v) return q.options[j].label;
    }
    return '';
  }
  var IMAGE_NAME = { city: 'ママチャリ・シティサイクル', school: '通学用の自転車', ebike: '電動アシスト自転車', esport: 'スポーツタイプの電動アシスト（e-bike）', town: 'シンプルでおしゃれな街乗り車', cross: 'クロスバイク', road: 'ロードバイク', tour: '旅や未舗装の道を走る自転車', mini: '小さめの車輪の自転車', mtb: 'マウンテンバイク' };
  var USE_TAG = { commute: '通勤・通学', shopping: '街乗り・買い物', town: '街乗り・買い物', ride: 'サイクリング', fitness: 'スポーツ・フィットネス' };
  var USE_SAY = { commute: '通勤・通学', shopping: '買い物や用事', town: '街の散策', ride: '休日のサイクリング', fitness: '運動・体力づくり' };

  /* 予算（税込の円）。上は少しだけ超えてよい（「あと◯円足せるなら」の枠に使う） */
  var BUDGET = {
    b3: [0, 30000], b5: [30000, 50000], b8: [50000, 80000], b10: [80000, 100000], b13: [100000, 130000],
    b16: [130000, 160000], b20: [160000, 200000], b30: [200000, 300000], b50: [300000, 500000], b99: [500000, 3000000],
    k2: [0, 20000], k3: [20000, 39999], k5: [40000, 59999], k6: [60000, 300000],
  };
  var TAX = 1.1;
  var pin = function (p) { return Math.floor(p.p * TAX); };
  // 公式通販サイトに載っていない商品は価格を伏せる（#973・データの na は diagnosis-data.mjs が model.ec_url の有無で付ける）。
  // 予算との合い方は内部では見るが、画面には金額も差額も出さない
  var ASK = '価格は店頭でご案内しています';
  var priceText = function (p) { return p.na ? ASK : yen(p.pi); };
  var yen = function (n) { return '¥' + Math.floor(n).toLocaleString('ja-JP'); };
  var man = function (n) { return (n / 10000 >= 10 ? Math.round(n / 10000) : Math.round(n / 1000) / 10) + '万円'; };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  /* ───────────── 商品の下ごしらえ ───────────── */
  var KIDS_RE = /子供用|幼児用|キックバイク/;
  var KIDSCARRY_RE = /ギュット|bikke|HYDEE|babby|kiss|トレフェール/i;
  var ESPORT_RE = /XEALT|CRAIG(?! Alley)|ハリヤ|ベロスター(?!・ミニ|･ミニ)|JF1|JG1|JR1|Topstone|CROSSCORE|ROADREX|VIENTA|FES MOTOR|E-POWER|eONE|E-UNITY|MANTUS|JE-260e|E-FAT|Xds|DAVOS|CRUISE URBAN/i;
  var ECARGO_RE = /カーゴ|CARGO|HAUL|ワゴン|Carigo|PORTER|WAGON/i;
  var STEEL_RE = /chromoly|steel|クロモリ|スチール|Cromor/i;

  function familyOf(p) {
    if (KIDS_RE.test(p.bt || '')) return 'kids';
    if (/一輪車/.test(p.bt || '')) return 'skip';
    if (p.el) {
      if ((p.us || []).indexOf('子どもを乗せる') >= 0 || /front|rear|both/.test(p.cs || '') || KIDSCARRY_RE.test(p.t)) return 'e-kids';
      if (ECARGO_RE.test(p.t)) return 'e-cargo';
      if (ESPORT_RE.test(p.t) || /700C|27\.5|29|650/.test(p.ts || '')) return 'e-sport';
      if (/^(14|16|18|20)インチ$/.test(p.ts || '') || p.fo) return 'e-mini';
      return 'e-city';
    }
    var bt = p.bt || '';
    // 鉄のフレームで未舗装も走れるスポーツ車は「旅・未舗装向け」。データの種類（クロス／ロード）のままだと、
    // ドロップハンドルの旅自転車を「クロスバイク」と呼んでしまう（round-1 P6）
    if (/ロード|クロス|マウンテン/.test(bt) && STEEL_RE.test(p.frm || '') && (p.srf || []).indexOf('未舗装も可') >= 0) return 'tour';
    if (/ロード/.test(bt)) return 'road';
    if (/クロス|スポーツバイク/.test(bt)) return 'cross';
    if (/マウンテン/.test(bt)) return 'mtb';
    if (/小径/.test(bt) || p.fo) return 'mini';
    if (/ママチャリ|シティ/.test(bt)) return 'city';
    return 'other';
  }
  var FAMILY_NAME = {
    road: 'ロードバイク', cross: 'クロスバイク', mtb: 'マウンテンバイク', mini: '小径車', city: 'シティサイクル', tour: '旅・未舗装も走れるスポーツ車',
    'e-city': '電動アシスト（シティタイプ）', 'e-mini': '電動アシスト（小径タイプ）', 'e-sport': '電動アシスト（スポーツタイプ）',
    'e-kids': '電動アシスト（子乗せタイプ）', 'e-cargo': '電動アシスト（荷物を積むタイプ）', kids: '子ども用自転車', other: '自転車',
  };
  function imageMatch(img, f) {
    if (!img || img === 'undecided') return false;
    if (img === 'ebike') return f.indexOf('e-') === 0;
    if (img === 'esport') return f === 'e-sport';
    if (img === 'city') return f === 'city' || f === 'e-city';
    if (img === 'mini') return f === 'mini' || f === 'e-mini';
    if (img === 'cross') return f === 'cross';
    if (img === 'school') return f === 'city';
    if (img === 'tour') return f === 'tour';
    if (img === 'town') return f === 'cross' || f === 'mini' || f === 'city';
    return f === img;
  }
  /* 表示用の名前。商品名についた販促の言葉（限定特価など）は見出しに出さない（round-1 P3・P10） */
  function displayName(p) {
    var t = String(p.t).replace(/限定特価|【[^】]*】/g, '').replace(/\s+/g, ' ').trim();
    // 商品名の頭にブランド名があれば外す（見出しの上にブランド名が出ている・round-2 P2「RENAULT RENAULT」）
    if (p.v && t.toUpperCase().indexOf(String(p.v).toUpperCase() + ' ') === 0) t = t.slice(String(p.v).length + 1);
    return t;
  }
  /* 適応身長の書き方。上限なし→「〜cm以上」、全サイズを足した幅（30cm超）→サイズにより異なる */
  function heightText(p) {
    if (p.hmin == null) return '';
    if (!p.hmax) return p.hmin + 'cm以上';
    return p.hmin + '〜' + p.hmax + 'cm' + (p.hmax - p.hmin > 30 ? '（サイズ展開の全体。合うサイズは店舗で）' : '');
  }
  function gearsOf(p) { return p.gr === '外装' ? 'ext' : p.gr === '内装' ? 'int' : p.gr === '変速なし' ? 'none' : ''; }
  function kidsSize(p) {
    var m = /(\d{2})インチ/.exec(p.ts || '') || /(\d{2})(?:\D*$)/.exec(String(p.t).replace(/（.*?）|\(.*?\)/g, ''));
    var n = m ? parseInt(m[1], 10) : 0;
    return n >= 10 && n <= 26 ? n : 0;
  }
  /* 同じ車種の色違い・年式違い・限定カラーを1つにまとめるための名前 */
  function baseName(p) {
    return (p.v + ' ' + String(p.t))
      .replace(/【.*?】|（.*?）|\(.*?\)/g, '')
      .replace(/限定特価|限定カラー|完組|完成車|Limited Color|Limited Edition|\d{4}年モデル/gi, '')
      .replace(/\s+/g, ' ').trim().toUpperCase();
  }
  function prep(products) {
    return products.map(function (p) {
      var x = {};
      for (var k in p) if (Object.prototype.hasOwnProperty.call(p, k)) x[k] = p[k];
      x.fam = familyOf(p);
      x.gear = gearsOf(p);
      x.pi = pin(p);
      x.base = baseName(p);
      x.ks = x.fam === 'kids' ? kidsSize(p) : 0;
      x.kick = /キックバイク/.test(p.bt || '') || /ストライダー|STRIDER|ランバイク/i.test(p.t);
      x.demo = /\u8a66\u4e57/.test(p.t); // 試乗車は候補から外す
      // E-Labo の店頭の車体は試乗車。在庫の店舗に数えない（ほかに在庫の店舗が無い車体は「店舗在庫なし」になる）
      if ((p.sh || []).some(function (s) { return s.h === 'elabo'; })) {
        x.sh = p.sh.filter(function (s) { return s.h !== 'elabo'; });
        x.st = Math.max(0, (p.st || 0) - 1);
      }
      x.sty = p.sty || [];
      // 写真から付けた「ステップスルー」が、上の管（トップチューブ）のあるスポーツ車にも付いている
      // （ベロスター・PAS CRAIG・TB1 など）。スポーツ車はフレームの形の記載（U形・V形など）があるときだけ信じる（2026-10-09 本間さん）
      if (/^(road|cross|mtb|tour|e-sport)$/.test(x.fam) && !/U形|V形|H形|スタッガード/.test(p.frm || '')) x.sty = x.sty.filter(function (t) { return t !== 'ステップスルー'; });
      return x;
    });
  }

  /* ───────────── 合わないものは出さない（スコアで救わない） ───────────── */
  var CHILD_H = { h95: 95, h108: 108, h120: 120, h132: 132, h145: 148 };
  var CHILD_TS = { h95: [12, 14], h108: [14, 16, 18], h120: [18, 20, 22], h132: [20, 22, 24], h145: [24, 26] };
  /* 身長の区切りは10cm。区切りの真ん中が、適応身長に2cmの余裕で入るものだけ（round-1 P2: 175cmに180〜190cm） */
  function fitsAdult(p, a) {
    if (!a.height || p.hmin == null) return true;
    var h = Number(a.height), lo = p.hmin, hi = p.hmax == null ? p.hmin + 25 : p.hmax;
    return h >= lo - 2 && h <= hi + 2;
  }
  function fitsChild(p, a) {
    var h = CHILD_H[a.child_height];
    if (!h) return true;
    if (p.hmin != null) {
      var hi = p.hmax == null ? p.hmin + 20 : p.hmax;
      return h >= p.hmin - 3 && h <= hi + 3;
    }
    if (p.kick) return a.child_height === 'h95' || a.child_height === 'h108';
    if (!p.ks) return false; // 大きさが分からない子ども用は勧めない（合わないと乗れない）
    return CHILD_TS[a.child_height].indexOf(p.ks) >= 0;
  }
  function hardFilter(list, a) {
    return list.filter(function (p) {
      if (p.demo || p.fam === 'skip') return false;
      // 写真の無い車体は勧めない。形も色も確かめられないものを「本命」にしない（2026-10-14 ペルソナ点検）
      if (!p.img) return false;
      if (a.rider === 'child') return p.fam === 'kids' && fitsChild(p, a);
      if (p.fam === 'kids') return false;
      if (a.electric === 'yes' && !p.el) return false;
      if (a.electric === 'no' && p.el) return false;
      if (a.rider === 'kidscarry') {
        // 子乗せは「乗せられる」と分かっている車体だけ。電動以外を選んだ人にはシティ型の非電動も出す
        if (p.el && p.fam !== 'e-kids') return false;
        if (!p.el && !(p.fam === 'city' && (p.us || []).indexOf('子どもを乗せる') >= 0)) return false;
        if (a.kids_count === '2' && p.cs && p.cs !== 'both' && p.cs !== 'none' && !/both/.test(p.cs)) {
          // 前だけ・後ろだけの標準装備でも、もう一方は後付けできる車種が多い。外さずに注意で伝える
        }
      }
      // 子どもを乗せない人に、子乗せの車体（子乗せ電動・チャイルドシート付き）は出さない（2026-10-09 本間さん
      // 「わたしが乗る＞特に決めてない で子乗せ電動がメインになるのはおかしい」）
      if (a.rider !== 'kidscarry' && (p.fam === 'e-kids' || /front|rear|both/.test(p.cs || ''))) return false;
      // スカート・膝が気になる人に、またぐ高さのある形（ロード・クロス・MTB・ツーリング・スポーツ電動）は出さない
      if ((has(a, 'skirt') || has(a, 'knee')) && /^(road|cross|mtb|tour|e-sport)$/.test(p.fam) && !/U形|V形|H形|スタッガード/.test(p.frm || '')) return false;
      if (a.dist === 'long' && p.gear === 'none') return false;
      if (!fitsAdult(p, a)) return false;
      return true;
    });
  }

  /* ───────────── 答え → 求めること（need）→ 点数と理由 ─────────────
     need: { id, w, ask: 答えの言い換え, test(p) → null（データ無し）| false（合わない）| {f: 事実, y: その意味} }
     合えば w 点と理由1行。合わなければ pen 点を引き、care（気をつける点）を残す。 */
  function needs(a, brands) {
    var N = [];
    var add = function (n) { N.push(n); };
    var spec = function (p) { var b = brands[p.v || '']; return !!(b && b.spec); };
    // 扱う店舗の限られるブランド（平均の在庫店舗数が3以下）。価格に関係なく「人と被らない」の事実になる
    var niche = function (p) { var b = brands[p.v || '']; return !!(b && (b.spec || (b.avgSt != null && b.avgSt <= 3))); };

    if (a.rider === 'child') return childNeeds(a, add), N;

    // 思い描いている自転車
    if (a.image && a.image !== 'undecided') add({ id: 'image', w: 30, ask: '思い描いているのは「' + IMAGE_NAME[a.image] + '」',
      test: function (p) {
        if (!imageMatch(a.image, p.fam)) return false;
        if (a.image === 'school') {
          // 通学車: 27インチ・変速つき・通学向けを優先。26インチは半分（round-1 P9「26インチは小さく見える」）
          var school = (p.us || []).indexOf('通勤・通学') >= 0;
          if (/27インチ/.test(p.ts || '') && school) return { f: '27インチの通学向けシティサイクル', y: '中高生の通学で多い大きさと形です' };
          if (/27インチ/.test(p.ts || '')) return { f: '27インチのシティサイクル', y: '通学で多い大きさです', half: true };
          // 26インチ以下は通学車の形とは言わない（点も入れない）。27インチがあればそちらが上に来る
          return school ? null : false;
        }
        if (a.image === 'town') {
          var hit = p.sty.filter(function (t) { return ['クラシック', 'レトロ', 'ヴィンテージ', '革サドル', 'ナチュラル', '北欧', 'ミニベロ'].indexOf(t) >= 0; });
          if (p.sty.indexOf('太タイヤ') >= 0 || (p.srf || []).indexOf('山道・トレイル') >= 0) return false;
          if (hit.length) return { f: FAMILY_NAME[p.fam] + '（' + hit.slice(0, 2).join('・') + '）', y: '街に置いて絵になる、すっきりした形です' };
          if (niche(p)) return { f: p.v + 'の' + FAMILY_NAME[p.fam], y: '扱う店舗の限られるブランドの、街乗り向けの形です' };
          return { f: FAMILY_NAME[p.fam], y: '', half: true, quiet: true };
        }
        return { f: FAMILY_NAME[p.fam], y: '思い描いている形の一台です' };
      }, pen: 15 });

    // 電動を思い描いていて、長い道のり・走りに行く・スポーティ好み → スポーツタイプの電動
    if (a.image === 'ebike' && (a.dist === 'long' || uses(a, 'ride') || uses(a, 'fitness') || a.look === 'sporty' || a.priority === 'speed')) add({ id: 'esport', w: 16, ask: a.dist === 'long' ? '片道10km以上を電動で' : '電動で走りに行きたい', crit: '車輪の大きいスポーツタイプの電動を優先',
      test: function (p) {
        if (p.fam !== 'e-sport') return p.fam === 'e-kids' || p.fam === 'e-mini' ? false : null;
        var big = /700C|27\.5|29/.test(p.ts || '');
        return { f: 'スポーツタイプの電動アシスト' + (p.ts ? '（' + p.ts + '）' : ''), y: big ? '車輪が大きく、長い道のりを軽く進めます' : 'スポーツ車の形で、長い道のりを軽快に進めます' };
      } });
    // 乗っている自分（価値観）。形の名前ではなく、その時間に合う作りかどうか
    var MOOD = {
      swift: { ask: '風を切って、すいすい進みたい', test: function (p) {
        if (/^(road|cross)$/.test(p.fam) && p.gear === 'ext') return { f: FAMILY_NAME[p.fam] + '・外装変速', y: 'こぐ力がそのまま前に進む、軽快な作りです' };
        if (p.fam === 'e-sport' || p.fam === 'mini' || p.fam === 'tour') return { f: FAMILY_NAME[p.fam], y: 'スポーツ寄りの作りです', half: true };
        return /city|kids/.test(p.fam) ? false : null; } },
      stroll: { ask: '景色を眺めながら、のんびり走りたい', test: function (p) {
        if (p.fam === 'road') return false;
        var up = p.sty.filter(function (t) { return ['ステップスルー', 'クラシック', 'ナチュラル', 'フラットバー', '曲線基調'].indexOf(t) >= 0; });
        if (/city|mini|e-city|e-mini/.test(p.fam) || up.length) return { f: up.length ? up.slice(0, 2).join('・') : FAMILY_NAME[p.fam], y: '上体を起こして乗る形で、まわりを見ながら走れます', half: !up.length };
        return null; } },
      sweat: { ask: '体を動かして、汗をかきたい', test: function (p) {
        if (/^(road|cross|mtb|tour)$/.test(p.fam)) return { f: FAMILY_NAME[p.fam], y: 'こいだ分だけ進む、運動向きの作りです' };
        if (p.el) return p.fam === 'e-sport' ? { f: 'スポーツタイプの電動', y: '電動でも、こぐ動きはしっかりあります', half: true } : false;
        return null; } },
      errand: { ask: '荷物も用事も、まとめて片づけたい', test: function (p) {
        if (p.sty.indexOf('カゴあり') >= 0 || p.sty.indexOf('バスケット') >= 0) return { f: 'カゴ付き', y: '買い物や用事の荷物をそのまま載せられます' };
        if (/^(city|e-city)$/.test(p.fam)) return { f: FAMILY_NAME[p.fam], y: '荷物を載せる前提の形です', half: true };
        return /^(road|mtb)$/.test(p.fam) ? false : null; } },
      roam: { ask: '知らない道や遠くの町へ、足を延ばしたい', test: function (p) {
        if (p.fam === 'tour' || (p.srf || []).indexOf('未舗装も可') >= 0) return { f: kindText(p), y: '舗装の切れた道まで足を延ばせる作りです' };
        if (/^(road|cross|e-sport)$/.test(p.fam) && p.gear === 'ext') return { f: FAMILY_NAME[p.fam] + '・外装変速', y: '長い道のりを、ギアを選びながら走れます', half: true };
        return /city|kids/.test(p.fam) ? false : null; } },
    };
    // 価値観は「合わない」と決めつけない（点を引くだけ）。のんびり派のシティ車を「答えに反する」と数えて、
    // 候補が1台しか出なかった（2026-10-09 納得チェック）
    if (a.mood && MOOD[a.mood]) add({ id: 'mood', w: 12, soft: true, ask: MOOD[a.mood].ask, test: MOOD[a.mood].test, pen: 6 });

    // 使い方
    (a.uses || []).forEach(function (u, i) {
      if (!USE_TAG[u]) return;
      add({ id: 'use' + i, w: i ? 8 : 16, ask: (i ? 'ほかに「' : 'おもに「') + label('use', u, a) + '」',
        test: function (p) { return (p.us || []).indexOf(USE_TAG[u]) >= 0 ? { f: 'メーカーの想定用途に「' + USE_TAG[u] + '」', y: '', quiet: true } : null; } });
    });

    // 子乗せ
    if (a.rider === 'kidscarry') {
      add({ id: 'kids', w: 26, ask: a.kids_count === '2' ? '2人を前とうしろに乗せる' : a.kids_count === '1+' ? 'いまは1人、いずれ2人を乗せる' : '子どもを1人乗せる',
        test: function (p) {
          if (p.cs === 'both') return { f: '前の席にも、うしろの席にも対応した車体', y: a.kids_count === '1' ? '下のお子さんが生まれたら、席を足して2人を乗せられます' : '最初から付いている席と、もう1つ足す席の組み合わせ・費用は店舗で確かめてください' };
          if (p.cs === 'front') return { f: '前にチャイルドシートが付いた形', y: a.kids_count === '1' ? '1〜3歳ごろのお子さんを前に乗せられます' : 'うしろの席は後から付けられるか、店舗で確かめてください' };
          if (p.cs === 'rear') return { f: 'うしろにチャイルドシートが付いた形', y: a.kids_count === '1' ? '幼稚園・保育園の年齢のお子さんを乗せられます' : '前の席は後から付けられるか、店舗で確かめてください' };
          if (p.fam === 'e-kids') return { f: '子どもを乗せる用途の電動アシスト', y: 'チャイルドシートの付け方は店舗でご相談ください' };
          return null;
        } });
      if (a.kids_count === '2') add({ id: 'kids2', w: 18, ask: '2人を乗せる',
        test: function (p) { return p.cs === 'both' ? { f: '2人乗せ（前とうしろ）に対応', y: '', quiet: true } : null; },
        care: function (p) { return p.cs === 'both' ? '' : '2人乗せには前とうしろの席が要ります。もう1つの席を付けられるかは店舗で確かめてください'; } });
      if (a.kids_age === 'both') add({ id: 'kage', w: 10, ask: '1〜3歳の子と、3歳〜小学校前の子',
        test: function (p) {
          if (p.cs === 'front') return { f: '前の席が付いた形', y: '小さいほうのお子さんを前に。うしろの席は足して使います' };
          if (p.cs === 'rear') return { f: 'うしろの席が付いた形', y: '大きいほうのお子さんをうしろに。前の席は足して使います' };
          return null;
        } });
      if (a.kids_age === 'front' || a.kids_age === 'young2') add({ id: 'kage', w: 10, ask: '乗せるのは1〜3歳ごろ',
        test: function (p) { return p.cs === 'front' || p.cs === 'both' ? { f: '前の席がある', y: '小さいお子さんを目の届く前に乗せられます' } : null; } });
      if (a.kids_age === 'rear') add({ id: 'kage', w: 10, ask: '乗せるのは3歳〜小学校に入る前',
        test: function (p) { return p.cs === 'rear' || p.cs === 'both' ? { f: 'うしろの席がある', y: '大きくなったお子さんを乗せる位置です' } : null; } });
    }

    // 距離
    if (a.dist === 'long') add({ id: 'dist', w: 16, ask: '片道10km以上走る',
      test: function (p) {
        if (p.el) return { f: '電動アシスト', y: '長い道のりでも、こぎ続ける力をモーターが補います' };
        if (p.gear === 'ext' || p.gear === 'int') return { f: '変速つき', y: '長い道のりを、坂や向かい風に合わせてギアを選んで走れます' };
        return p.gear === 'none' ? false : null;
      } });
    else if (a.dist === 'mid') add({ id: 'dist', w: 8, ask: '片道3〜10km走る',
      test: function (p) {
        if (p.gear === 'none' && !p.el) return false;
        if (!(p.el || p.gear === 'ext' || p.gear === 'int')) return null;
        // 種類ごとに言い方を変える（ロードに「数キロを楽に」はママチャリ向けに読める・round-1 P4）
        if (p.fam === 'road' || p.fam === 'tour') return { f: (p.gear === 'ext' ? '外装変速' : '変速つき') + 'の' + FAMILY_NAME[p.fam], y: 'ギアを細かく選べるので、毎日の数キロも休日の遠出も同じ一台で走れます' };
        if (p.fam === 'cross') return { f: 'クロスバイク・' + (p.gear === 'ext' ? '外装変速' : '内装変速'), y: '数キロの道を、信号のこぎ出しも軽く走れます' };
        return { f: p.el ? '電動アシスト' : '変速つき', y: '数キロの道のりで、向かい風や上りに合わせて楽に走れます', half: true };
      },
      care: function (p) { return p.gear === 'none' && !has(a, 'hill') ? '変速がないので、数キロ走ると脚に負担がかかります' : ''; } });
    else if (a.dist === 'short' && !has(a, 'hill')) add({ id: 'dist', w: 5, ask: '近所（〜3km）が中心',
      test: function (p) { return p.gear === 'none' || p.gear === 'int' ? { f: p.gear === 'none' ? '変速なしのシンプルな作り' : '内装変速', y: '近所の行き来なら、手入れの少ない作りで足ります' } : null; } });

    // 道の様子
    if (has(a, 'hill')) add({ id: 'hill', w: a.electric === 'no' ? 14 : 22, ask: '坂道がある',
      test: function (p) {
        if (p.el) return { f: '電動アシスト', y: '上り坂で、モーターが脚の力を補います' };
        if (p.gear === 'ext' || p.gear === 'int') return { f: '変速つき', y: '坂ではギアを軽くして上れます', half: true };
        return p.gear === 'none' ? false : null;
      }, pen: 8, care: function (p) { return p.gear === 'none' && !p.el ? '変速がないので、坂では脚に負担がかかります' : ''; } });
    if (has(a, 'night')) add({ id: 'night', w: 14, ask: '暗くなってからも乗る',
      test: function (p) { return p.li ? { f: 'オートライト', y: '暗くなると自動で点くので、点け忘れがありません' } : null; },
      care: function (p) { return p.li ? '' : (/cross|road|tour|mtb|mini/.test(p.fam) ? 'オートライトの記載がありません。夜に乗るにはライトが要るので、乗り出しのときに店舗で一緒に選べます' : 'ライトの種類は店舗で確かめてください'); } });
    if (has(a, 'rain')) add({ id: 'rain', w: 10, ask: '雨の日も乗る',
      test: function (p) {
        var fen = p.sty.indexOf('フェンダーあり') >= 0;
        if (fen && p.gear === 'int') return { f: '泥よけ付き・内装変速', y: '泥よけが跳ね上げを受け止め、変速の部品は軸の中で雨をかぶりにくい作りです' };
        if (fen) return { f: '泥よけ付きの形', y: '雨の日に、タイヤの跳ね上げが服にかかりにくくなります' };
        if (p.gear === 'int') return { f: '内装変速', y: '変速の部品が車輪の軸の中にあり、雨や泥をかぶりにくい作りです', half: true };
        return null;
      },
      care: function (p) { return p.sty.indexOf('フェンダーあり') >= 0 || p.fam === 'city' || /^e-(city|kids)$/.test(p.fam) ? '' : '泥よけの記載がありません。雨の日に乗るなら、付けられるかを店舗で確かめてください'; } });
    if (has(a, 'load')) add({ id: 'load', w: 12, ask: '荷物が多い',
      test: function (p) {
        if (p.fam === 'e-cargo') return { f: '荷物を積むための電動アシスト', y: '大きな荷台に重い荷物を載せられます' };
        if (p.sty.indexOf('カゴあり') >= 0 || p.sty.indexOf('バスケット') >= 0) return { f: 'カゴ付きの形', y: '買った物をそのまま入れて走れます' };
        if (p.fam === 'city' || p.fam === 'e-city' || p.fam === 'e-kids') return { f: FAMILY_NAME[p.fam], y: 'カゴや荷台を付けて、荷物を運ぶのに向いた形です', half: true };
        // 形を決めていない人の荷物に、カゴも荷台も付けにくいロード・MTBは勧めない（2026-10-09 納得チェック）
        if (/^(road|mtb)$/.test(p.fam) && (!a.image || a.image === 'undecided')) return false;
        return null;
      } });
    var low = lowFrame;
    if (has(a, 'knee')) add({ id: 'knee', w: 20, ask: 'またぎやすい低いフレームがいい',
      test: function (p) { return low(p) ? { f: 'フレームの低い形（ステップスルー）', y: '足を高く上げずに、前からまたいで乗り降りできます' } : (/road|cross|tour|mtb/.test(p.fam) ? false : null); }, pen: 10,
      care: function (p) { return low(p) ? '' : 'フレームの低さは写真で確かめにくいので、店舗で一度またいでみてください'; } });
    if (has(a, 'skirt')) add({ id: 'skirt', w: 12, ask: 'スカートで乗りたい',
      test: function (p) { return low(p) ? { f: 'フレームの低い形（ステップスルー）', y: 'スカートでも足を高く上げずに乗り降りできます' } : (p.fam === 'road' ? false : null); } });
    if (has(a, 'suit')) add({ id: 'suit', w: 10, ask: 'スーツ・革靴で乗りたい',
      test: function (p) {
        var fen = p.sty.indexOf('フェンダーあり') >= 0;
        if (p.fam === 'road' || p.fam === 'tour') return false;
        if (fen) return { f: '泥よけ付きの形', y: 'ズボンのすそや背中への跳ね上げを受け止めます' };
        if (p.sty.indexOf('フラットバー') >= 0 || /city|e-/.test(p.fam)) return { f: 'まっすぐなハンドル', y: '前かがみになりすぎない姿勢で乗れます', half: true };
        return null;
      },
      care: function (p) { return /cross|e-sport/.test(p.fam) ? 'ズボンのすそがチェーンに触れないか（チェーンカバーの有無）を店舗で確かめてください' : ''; } });
    if (has(a, 'tour')) add({ id: 'tour', w: 16, ask: '荷物を積んで旅もしてみたい',
      test: function (p) {
        if (STEEL_RE.test(p.frm || '')) return { f: '鉄（クロモリ）のフレーム', y: '荷物を積んで走る旅自転車に、昔から使われてきた素材です。荷台やバッグの付け方は店舗で確かめてください' };
        if ((p.srf || []).indexOf('未舗装も可') >= 0) return { f: '未舗装の道も走れる作り', y: '旅先で舗装が切れても先へ進めます', half: true };
        return p.fam === 'road' || p.fam === 'mini' ? false : null;
      } });
    if (has(a, 'dirt')) add({ id: 'dirt', w: 14, ask: '砂利道や山道も走りたい',
      test: function (p) {
        var s = p.srf || [];
        if (s.indexOf('山道・トレイル') >= 0 || p.fam === 'mtb') return { f: '山道を走れる作り（太いタイヤ）', y: '砂利や土の道でも、タイヤが地面をとらえます' };
        if (s.indexOf('未舗装も可') >= 0) return { f: '未舗装の道も走れる作り', y: '舗装の切れた道でも走れます' };
        return p.fam === 'road' || p.fam === 'city' ? false : null;
      } });

    // 置き場所
    // エレベーターで運ぶ人の本命は、折りたたみか小径車（2026-10-09 本間さん）。思い描いた形が別にあればそちらが先
    if (a.place === 'elev') add({ id: 'place', w: 24, ask: 'エレベーターで部屋まで運ぶ',
      test: function (p) {
        if (p.fo) return { f: '折りたたみ', y: 'たたむとエレベーターに収まりやすくなります' };
        if (p.fam === 'mini' || p.fam === 'e-mini') return { f: '小径車', y: '車体が短く、エレベーターに載せやすい大きさです' };
        if (p.wkg && p.wkg <= 13) return { f: '重さ' + p.wkg + 'kg（メーカー公表）', y: 'エレベーターまでの取り回しが軽い重さです', half: true };
        if (p.wt === '10kg未満') return { f: '重さ10kg未満', y: 'エレベーターまでの取り回しが軽い重さです', half: true };
        return null;
      },
      care: function (p) { return p.fo ? '' : '車体の長さがエレベーターに収まるか（前輪を上げて立てて載せられるか）を、ご自宅のエレベーターの奥行きと比べてください'; } });
    // 階段で運び上げられない重さは、ほかの答えの2つ分として数える（電動の小径車が本命になっていた・2026-10-09 納得チェック）
    else if (a.place === 'carry') add({ id: 'place', w: 20, hard: 2, ask: '階段で運び上げる',
      test: function (p) {
        if (p.el) return false;
        // 折りたためても、15kgを超えると運び上げは大変（2026-10-09 納得チェック: 15〜20kgの折りたたみが本命）
        if ((p.wkg && p.wkg > 15) || p.wt === '15〜20kg' || p.wt === '20kg以上') return false;
        if (p.fo) return { f: '折りたたみ', y: 'たたむと小さくなり、エレベーターや階段で運びやすくなります' };
        if (p.wkg && p.wkg <= 15) return { f: '重さ' + p.wkg + 'kg（メーカー公表）', y: p.wkg < 10 ? '自転車の中では軽い部類です' : '毎日運べる重さかは、店舗で一度持ち上げて確かめてください', half: p.wkg >= 10 };
        if (p.wkg && p.wkg > 15) return false;
        if (p.wt === '10kg未満') return { f: '重さ10kg未満', y: '自転車の中では軽い部類です' };
        if (p.wt === '10〜15kg') return { f: '重さ10〜15kg', y: '毎日運べる重さかは、店舗で一度持ち上げて確かめてください', half: true };
        if (p.wt === '15〜20kg' || p.wt === '20kg以上') return false;
        // 重さが分からないものは、階段で運ぶ人には勧めない（round-2 P7）
        return false;
      }, pen: 18, care: function (p) { return p.el ? '電動アシストは重さがあるので、階段で運び上げるのは大変です' : (p.wt === '15〜20kg' || p.wt === '20kg以上') ? '重さが15kgを超えるので、運び上げるときは店舗で一度持ち上げてみてください' : (!p.wkg && !p.wt ? '重さの公表値が手元にありません。運び上げるなら、店舗で持ち上げて確かめてください' : ''); } });
    else if (a.place === 'car') add({ id: 'place', w: 18, ask: '車や電車に載せたい',
      test: function (p) { return p.fo ? { f: '折りたたみ', y: 'たたんで車のトランクに積めます。電車では専用の袋に入れて持ち込みます' } : (p.el ? false : null); } });
    else if (a.place === 'indoor') add({ id: 'place', w: 6, ask: '室内に置く',
      test: function (p) { return p.fo || p.fam === 'mini' ? { f: FAMILY_NAME[p.fam] === '小径車' ? '小径車' : '折りたたみ', y: '場所をとらずに置けます' } : null; } });

    // 電動か迷っている（重さ・充電が心配）。電動の車体には重さを必ず添える（round-2 P3）
    if (a.electric === 'unsure') add({ id: 'elq', w: 9, ask: '電動は重さや充電が気になる', pen: 6,
      test: function (p) {
        if (!p.el) return { f: '電動ではない車体', y: 'バッテリーが無い分軽く、充電もいりません', half: true };
        if (p.wt === '20kg以上' && !p.wkg) return false;
        return weightText(p) ? { f: '重さ' + weightText(p) + (p.wkg ? '（メーカー公表）' : ''), y: '押して歩くときやスタンドを立てるときの重さです。店舗で一度押してみてください' } : null;
      },
      care: function (p) { return p.el ? (p.wt === '20kg以上' ? '重さは20kg以上あります。押して歩けるか、スタンドを立てられるかを店舗で一度試してください' : 'バッテリーの外し方と充電の場所・時間は、店舗で実物を見ながらお伝えします') : ''; } });
    // 電動を希望（ハードで絞った事実を理由に翻訳。ほかの理由で電動を言っていないときだけ出る）
    if (a.electric === 'yes') add({ id: 'el', w: 0, ask: a.image === 'ebike' ? '思い描いているのは電動アシスト' : '電動アシストにしたい',
      test: function (p) { return p.el ? { f: '電動アシスト', y: '電動の中から選んでいます', quiet: true } : null; } });

    // 決め手（2つまで。2つ目は重みを半分に・round-3 P7「見た目と軽さの両方が大事」）
    (a.priorities || []).forEach(function (pr, i) {
      var pid = i ? 'pri2' : 'pri', k = i ? 0.6 : 1;
      if (pr === 'easy') add({ id: pid, w: 18 * k, ask: 'ラクに走れることを大事にしたい',
        test: function (p) { return p.el ? { f: '電動アシスト', y: 'こぎ出しと上り坂が軽くなります' } : (p.gear ? { f: '変速つき', y: '道に合わせてペダルを軽くできます', half: true } : null); } });
      else if (pr === 'light') add({ id: pid, w: 20 * k, ask: '軽さ・扱いやすさを大事にしたい',
        test: function (p) {
          if (p.wkg && !p.el) return p.wkg < 10 ? { f: '重さ' + p.wkg + 'kg（メーカー公表）', y: '持ち上げるのも、取り回すのも軽い車体です' } : p.wkg <= 14 ? { f: '重さ' + p.wkg + 'kg（メーカー公表）', y: '自転車の中では軽い部類で、取り回しが楽です', half: true } : null;
          if (p.wt === '10kg未満') return { f: '重さ10kg未満', y: '持ち上げるのも、取り回すのも軽い車体です' };
          if (p.wt === '10〜15kg') return { f: '重さ10〜15kg', y: '自転車の中では軽い部類で、取り回しが楽です', half: true };
          if (p.wt === '20kg以上') return false;
          return p.el ? false : null;
        }, pen: 8, care: function (p) { return p.wt === '20kg以上' ? '重さが20kg以上あるので、持ち上げる場面には向きません' : (!p.wt && !p.wkg ? '重さの公表値が手元にありません。軽さは店舗で持ち上げて確かめてください' : ''); } });
      else if (pr === 'price') add({ id: pid, w: 18 * k, ask: '価格をおさえたい', price: true,
        test: function () { return null; } });
      else if (pr === 'tough') add({ id: pid, w: 16 * k, ask: '丈夫さ・手間の少なさを大事にしたい',
        test: function (p) {
          if (p.gear === 'int') return { f: '内装変速', y: '変速の部品が軸の中にあり、チェーンが外れにくく手入れが少なくて済みます' };
          if (p.fam === 'city' && p.gear === 'none') return { f: '変速なしのシンプルな作り', y: '壊れる部品が少なく、手入れの手間がかかりません', half: true };
          return null;
        } });
      else if (pr === 'design') add({ id: pid, w: 14 * k, ask: '見た目・デザインを大事にしたい',
        test: function (p) { return spec(p) ? { f: p.v + 'の一台', y: 'サイクルスポットでも扱う店舗が限られます' } : (p.sty.length >= 4 ? { f: '見た目の特徴がはっきりした一台', y: '', half: true, quiet: true } : null); } });
      else if (pr === 'speed') add({ id: pid, w: 20 * k, ask: '速さ・走る楽しさを大事にしたい',
        test: function (p) {
          if (p.fam === 'road') return { f: 'ロードバイク', y: '前に体を倒した姿勢で、速さを出しやすい形です' };
          if (p.fam === 'cross') return { f: 'クロスバイク', y: 'まっすぐなハンドルのまま、軽快に走れる形です', half: true };
          // 電動にしたい人の「速さ」は、電動の中のスポーツタイプで応える（電動を全部「合わない」にしない）
          if (p.el) return p.fam === 'e-sport' ? { f: 'スポーツタイプの電動', y: '車輪が大きく、軽快に走れる形です', half: true } : (a.electric === 'yes' ? null : false);
          if (p.fam === 'city') return false;
          return null;
        } });
      else if (pr === 'long') add({ id: pid, w: 14 * k, ask: '長く使えることを大事にしたい',
        test: function (p) {
          if (STEEL_RE.test(p.frm || '')) return { f: '鉄（クロモリ）のフレーム', y: '部品を替えながら長く乗る人の多い素材です' };
          if (p.gear === 'int') return { f: '内装変速', y: '変速の部品が軸の中にあり、汚れや雨に強い作りです' };
          return null;
        } });
      else if (pr === 'safe') add({ id: pid, w: 14 * k, ask: '子どもを乗せたときの乗りやすさを大事にしたい',
        test: function (p) { return /20インチ/.test(p.ts || '') && p.fam === 'e-kids' ? { f: 'タイヤは20インチ', y: '車体が低くおさまり、乗せ降ろしのときに足がつきやすい大きさです' } : null; } });

      // 見た目の好み（navi 由来の見た目タグとの一致）
    });

    /* 見た目の好み。合うタグがあれば理由に、反対のタグ（クラシック好きに太タイヤ・アスリート）なら外す方向。
       見た目を決め手にした人（デザイン重視・人と被らない）は重みを上げる（round-1 P7・P10「見た目の話が無い」） */
    if (a.look && LOOK_TAGS[a.look]) add({ id: 'look', w: a.priority === 'design' || a.style === 'unique' || a.image === 'town' ? 22 : 14, ask: '見た目は「' + label('look', a.look, a) + '」が好み',
      test: function (p) {
        var hit = p.sty.filter(function (t) { return LOOK_TAGS[a.look].indexOf(t) >= 0; });
        var ng = p.sty.filter(function (t) { return (LOOK_NG[a.look] || []).indexOf(t) >= 0; });
        if (hit.length >= 2 && ng.length < 2) return { f: '見た目の特徴は「' + hit.slice(0, 3).join('・') + '」', y: LOOK_SAY[a.look] };
        if (ng.length >= 2 || (ng.length && !hit.length)) return false;
        if (hit.length === 1) return { f: '見た目の特徴に「' + hit[0] + '」', y: LOOK_SAY[a.look], half: true };
        return null;
      }, pen: 6,
      care: function (p) { return p.sty.length ? '' : '見た目の特徴が手元のデータにありません。色や形は写真と店舗の実物で確かめてください'; } });

    // 付き合い方
    if (a.style === 'standard') add({ id: 'style', w: 12, ask: 'みんなが乗っている定番がいい',
      test: function (p) { return p.st >= 20 ? { f: p.st + '店舗に在庫のある車種', y: '多くの店舗で扱う定番です。近くの店舗で実物を見られます' } : (spec(p) ? false : null); }, pen: 6 });
    else if (a.style === 'long') add({ id: 'style', w: 14, ask: '気に入った一台を、直しながら長く',
      test: function (p) {
        if (STEEL_RE.test(p.frm || '')) return { f: '鉄（クロモリ）のフレーム', y: '部品を替えながら長く乗る人の多い素材です' };
        if (spec(p)) return { f: p.v + 'の一台', y: '流行に合わせて作り替えない、長く続くブランドの車体です', half: true };
        if (p.gear === 'int') return { f: '内装変速', y: '汚れに強く、手入れしながら長く使える作りです', half: true };
        return null;
      } });
    else if (a.style === 'unique') add({ id: 'style', w: 22, ask: '人と被らない、個性のある一台がいい',
      test: function (p) { return niche(p) ? { f: p.v + 'の一台', y: 'サイクルスポットでも扱う店舗が限られます' } : (p.st >= 40 ? false : null); }, pen: 10 });
    else if (a.style === 'custom') add({ id: 'style', w: 16, ask: '部品を替えて、自分好みに育てたい',
      test: function (p) {
        if (p.fam === 'cross' || p.fam === 'road' || p.fam === 'mtb') return { f: FAMILY_NAME[p.fam], y: 'ハンドル・サドル・タイヤなどを替えて、自分好みにしていける形です' };
        return p.el ? false : null;
      }, pen: 10, care: function (p) { return p.el ? '電動アシストは、部品を替えられる範囲が限られます' : ''; } });

    // 身長（ハードで絞り済み。合っている事実を理由にする）
    if (a.height) add({ id: 'height', w: 6, ask: '身長は' + label('height', a.height, a),
      test: function (p) {
        // 適応身長の公表が無いシティ車は、車輪の大きさで順番だけ下げる（150cm未満に27インチが本命になっていた・2026-10-09 納得チェック）。
        // 画面には「合わない」と書かない（公表値ではないので）
        if (p.hmin == null) return /city/.test(p.fam) && ((+a.height <= 145 && /27インチ/.test(p.ts || '')) || (+a.height >= 185 && /^(20|22|24)インチ$/.test(p.ts || ''))) ? false : null;
        if (p.hmax && p.hmax - p.hmin > 30) return null;
        // 答えた身長の帯（±5cm）の一部しか範囲に入らないときは、そう書く（round-4 P10「155〜165cmなのに乗れる範囲」）
        var h0 = +a.height;
        if ((p.hmin > h0 - 5) || (p.hmax && p.hmax < h0 + 5)) return { f: '適応身長' + heightText(p) + '（メーカー公表）', y: 'お答えの' + (h0 - 5) + '〜' + (h0 + 5) + 'cmの一部だけが範囲です。店舗でまたがって確かめてください', half: true };
        return { f: '適応身長' + heightText(p) + '（メーカー公表）', y: '身長が乗れる範囲に入っています' };
      }, pen: 10 });
    return N;
  }

  function childNeeds(a, add) {
    var h = CHILD_H[a.child_height];
    if (h) add({ id: 'size', w: 24, ask: 'お子さんの身長は' + label('child_height', a.child_height, a),
      test: function (p) {
        if (p.hmin != null) {
          // 伸びしろが少ない（上限まで8cm未満）ものは半分。すぐ小さくなる（round-1 P5）
          var room = p.hmax ? p.hmax - h : 20;
          return { f: '適応身長' + heightText(p) + '（メーカー公表）', y: p.hmax && room > 0 ? 'いまの身長から' + room + 'cmほど伸びるまで、公表の範囲に入ります' : 'いまの身長が乗れる範囲に入っています', half: room < 8 };
        }
        if (p.kick) return { f: 'ペダルの無いキックバイク', y: '足で地面をけって進み、バランスをとる練習になります' };
        if (p.ks) return { f: 'タイヤは' + p.ks + 'インチ', y: '合うかどうかは、店舗でまたがって確かめてください', half: true };
        return null;
      } });
    if (a.child_use === 'first') add({ id: 'cuse', w: 16, ask: 'はじめての自転車',
      test: function (p) {
        if (p.kick) return { f: 'キックバイク', y: 'ペダルの前に、バランスのとり方から覚えられます' };
        if (/補助輪/.test(p.t)) return { f: '補助輪つき', y: '乗る練習から始められます' };
        return null;
      } });
    if (a.child_use === 'play') add({ id: 'cuse', w: 8, ask: '公園や友だちの家へ',
      test: function (p) { return p.gear === 'none' ? { f: '変速なしのシンプルな作り', y: '操作がブレーキとペダルだけで、近所を走るのに扱いやすい作りです' } : null; } });
    if (a.child_use === 'far') add({ id: 'cuse', w: 16, ask: '坂のある道や少し遠くまで',
      test: function (p) { return p.gear === 'ext' || p.gear === 'int' ? { f: '変速つき', y: '坂ではギアを軽くして上れます' } : (p.gear === 'none' ? false : null); } });
    if (a.child_look === 'cute') add({ id: 'clook', w: 12, ask: 'かわいい・明るい色が好き',
      test: function (p) {
        if (p.sty.indexOf('パステル') >= 0) return { f: 'パステルなど明るい色のあるモデル', y: '色の名前と在庫は商品ページと店舗で確かめてください' };
        if (/ガールズ/.test(p.tg || '')) return { f: 'ガールズ向けの色・柄があるモデル', y: '色の名前と在庫は商品ページと店舗で確かめてください' };
        return p.tg && /ボーイズ/.test(p.tg) && !/ガールズ/.test(p.tg) ? false : null;
      } });
    if (a.child_look === 'cool') add({ id: 'clook', w: 10, ask: 'かっこいい・スポーティが好き',
      test: function (p) { return /ボーイズ/.test(p.tg || '') || p.sty.indexOf('スポーティ') >= 0 ? { f: 'スポーティな形のモデル', y: '', quiet: true } : null; } });
    if (a.child_look === 'simple') add({ id: 'clook', w: 10, ask: 'シンプルで、きょうだいでも使える',
      test: function (p) { return /男女共用/.test(p.tg || '') ? { f: '男の子にも女の子にも向けたモデル', y: 'きょうだいで乗り継ぎやすい色と形です' } : null; } });
  }

  var LOOK_SAY = { classic: 'お好みのクラシックな雰囲気に近い見た目です', modern: 'お好みのすっきりした雰囲気に近い見た目です', sporty: 'お好みのスポーティな雰囲気に近い見た目です', natural: 'お好みのやわらかい雰囲気に近い見た目です', bold: 'お好みの目を引く雰囲気に近い見た目です' };
  var LOOK_NG = {
    classic: ['太タイヤ', 'アスリート', 'カーボン感'],
    modern: ['ヴィンテージ', 'レトロ', 'クルーザー'],
    sporty: ['カゴあり', 'バスケット', 'クルーザー', 'レトロ'],
    natural: ['アスリート', 'カーボン感', '太タイヤ', 'ビビッド'],
    bold: ['モノクローム', '黒基調'],
  };
  var LOOK_TAGS = {
    classic: ['クラシック', 'レトロ', 'ヴィンテージ', '革', '革サドル', 'ナチュラル', '曲線基調'],
    modern: ['モダン', '直線基調', 'モノクローム', 'マット', 'メタル感', '黒基調'],
    sporty: ['スポーティ', 'ドロップハンドル', 'フラットバー', 'カーボン感', '太タイヤ', 'アスリート'],
    natural: ['ナチュラル', 'ステップスルー', '白基調', 'クラシック', 'パステル', '曲線基調'],
    bold: ['ビビッド', 'メタリック', 'グロス', 'カラフル'],
  };

  /* 予算の採点。範囲の中なら加点、少し上は減点（上の枠で使う）、大きく外れたら主枠から外す */
  function budgetFit(p, a) {
    var r = BUDGET[a.budget];
    if (a.budget === 'q') {
      if (p.pi < 50000) return { s: -15, ok: false };
      return { s: p.pi >= 80000 ? 8 : 0, ok: true };
    }
    if (!r) return { s: 0, ok: true };
    var lo = r[0], hi = r[1];
    if (p.pi <= hi && p.pi >= lo) return { s: 20, ok: true, inside: true };
    if (p.pi > hi) {
      if (p.pi <= hi * 1.15) return { s: -6, ok: false, stretch: true, over: p.pi - hi };
      if (p.pi <= hi * 1.35) return { s: -20, ok: false, stretch2: true, over: p.pi - hi };
      return { s: -60, ok: false };
    }
    // 予算より安い。少しなら問題ない（得をしている）。大きく安いのは「その予算で選ぶ意味がない」
    // 予算より安いのは悪くないが、予算の中を先に出す（round-2 P2・P7・P8「予算より2万円安いのが本命」）
    if (p.pi >= lo * 0.75) return { s: a.priority === 'price' ? 8 : 0, ok: true, under: true };
    if (a.priority === 'price') return { s: 0, ok: true, under: true };
    return { s: -25, ok: false };
  }

  function score(p, a, N, brands, env) {
    env = env || {};
    var s = 0, why = [], care = [], bad = 0, miss = [];
    for (var i = 0; i < N.length; i++) {
      var n = N[i];
      var r = n.test(p);
      if (r && typeof r === 'object') {
        var w = r.half ? n.w * 0.5 : n.w;
        s += w;
        why.push({ ask: n.ask, f: r.f, y: r.y, w: w, id: n.id, quiet: !!r.quiet });
      } else if (r === false) { if (n.pen) s -= n.pen; if (n.w >= 12 && n.id !== 'image' && !n.soft) { bad += n.hard || 1; miss.push(n.ask); } }
      if (n.care) { var c = n.care(p); if (c) care.push(c); }
    }
    var b = budgetFit(p, a);
    s += b.s;
    // 予算の下の端との差額は書かない（「ご予算より¥11,610以上安い」は何から引いたか分からない・2026-10-09 本間さん）
    if ((b.inside || (b.under && a.priority !== 'price')) && a.budget && BUDGET[a.budget]) why.push({ ask: 'ご予算は' + label('budget', a.budget, a), f: p.na ? ASK : '税込' + yen(p.pi), y: 'ご予算内に収まる価格です', w: b.inside ? 8 : 4, id: 'budget' });
    if (a.priority === 'price' && BUDGET[a.budget]) {
      var lo = BUDGET[a.budget][0], hi = BUDGET[a.budget][1];
      var pos = Math.max(0, Math.min(1, (p.pi - lo) / Math.max(1, hi - lo)));
      s += 18 * (1 - pos);
      if (pos < 0.5 && b.ok && !p.na) why.push({ ask: '価格をおさえたい', f: '税込' + yen(p.pi), y: 'ご予算の中でも、おさえた価格です', w: 14, id: 'pri' });
    }
    // 見た目を決め手にした人に、見た目の手がかりが何も無い車体は下げる
    if (a.look && (a.priority === 'design' || a.style === 'unique' || a.image === 'town') && !(p.sty || []).length) s -= 10;
    // 店舗の在庫は、同じくらい合うときの並び順にだけ使う（2026-10-09 本間さん「店頭在庫にこだわりすぎると
    // 選択肢が減るので、まずはスポットで扱いのある自転車選びに特化」）。前は在庫の多さで最大19点動かしていた。
    // いまは在庫ありで1点・行けるあたりに在庫ありで1点だけ
    var st = p.st || 0;
    s += st >= 1 ? 1 : 0;
    // 行けるあたりに在庫がある（地域を答えた人・位置情報を許可した人）
    var nc = nearCount(p, env.stores || [], env.geo);
    if (nc != null) {
      s += nc >= 1 ? 1 : 0;
      if (nc >= 1) why.push({ ask: env.geo.n ? 'お店に行くなら' + env.geo.n : 'いまいる場所', f: (env.geo.n ? env.geo.n + 'のあたりの' : '近くの') + nc + '店舗に在庫', y: a.timing === 'soon' ? '電話で在庫を確かめて、そのまま見に行けます' : '実物を見に行ける距離です', w: 7, id: 'near' });
    }
    if (!p.img) s -= 12;
    // 専門ブランドの「際立ち」（人と被らない・デザイン重視のときだけ）
    if ((a.style === 'unique' || a.priority === 'design') && brands[p.v] && brands[p.v].spec) s += 4;
    if (p.hmin == null && p.fam !== 'kids' && a.height) care.push('適応身長の公表値が手元にありません。店舗でまたがってサイズを確かめてください');
    if (p.fam === 'kids' && p.hmax && CHILD_H[a.child_height] && CHILD_H[a.child_height] >= p.hmax - 4) care.push('いまの身長が適応範囲の上のほうです。ひとつ大きいサイズも店舗で比べてください');
    // 同じ種類の理由は1つに（電動アシストが3回並ぶのを防ぐ）。重い順
    why.sort(function (x, y) { return y.w - x.w; });
    // 同じ事実に結びついた答えは1行にまとめる（「丈夫さ」と「雨の日」が両方「内装変速」なら、答えを2つ並べる・round-2）
    var seen = {}, uniq = [];
    why.forEach(function (w) {
      var k = w.f;
      if (seen[k]) { seen[k].ids.push(w.id); if (w.w > seen[k].wmax) seen[k].wmax = w.w; if (!w.quiet && seen[k].asks.indexOf(w.ask) < 0 && seen[k].asks.length < 2) { seen[k].asks.push(w.ask); seen[k].ask = seen[k].asks.join('」「'); } return; }
      var c = {}; for (var x in w) c[x] = w[x];
      c.asks = [w.ask]; c.ids = [w.id]; c.wmax = w.w; seen[k] = c; uniq.push(c);
    });
    return { s: s, why: uniq, care: care, budget: b, bad: bad, miss: miss, near: nc };
  }

  /* ───────────── 選び方（役で選ぶ） ───────────── */
  function dedupe(list) {
    var seen = {}, out = [];
    list.forEach(function (r) { if (seen[r.p.base]) return; seen[r.p.base] = 1; out.push(r); });
    return out;
  }

  /* 見た目を決め手にした人（デザイン重視・人と被らない・おしゃれな街乗り）には、見た目の理由が立つ車体だけを並べる（round-2 P7・P10） */
  function lookFit(r, a, strict) {
    if (!a.look || !LOOK_TAGS[a.look] || !(a.priorities.indexOf('design') >= 0 || a.style === 'unique' || a.image === 'town')) return true;
    if (strict) return r.why.some(function (w) { return w.id === 'look'; });
    // 見た目の理由がある、または見た目の手がかり（タグ）があって好みと反対ではないもの
    return r.why.some(function (w) { return w.id === 'look'; }) || ((r.p.sty || []).length > 0 && !r.bad);
  }
  /* フレームの低い形と分かる車体（写真のタグか、フレームの形の記載） */
  function lowFrame(p) { return (p.sty || []).indexOf('ステップスルー') >= 0 || /U形|V形|H形|スタッガード/.test(p.frm || ''); }
  function pick(scored, a, brands) {
    // 軽さを大事にする・階段で運ぶ人には、重さの分からない車体を比べる候補に入れない（round-4 P7）
    var wNeed = a.priorities.indexOf('light') >= 0 || a.place === 'carry';
    // スカート・膝が気になる人には、低い形と分かる車体を並べる（2026-10-09 納得チェック: 本命は低い形なのに、別の選び方が分からない小径車）
    var lowNeed = has(a, 'skirt') || has(a, 'knee');
    var lookOK = function (r) { return lookFit(r, a) && (!wNeed || !!(r.p.wkg || r.p.wt)) && (!lowNeed || lowFrame(r.p)); };
    var main = scored.filter(function (r) { return r.budget.ok; });
    if (!main.length) main = scored.filter(function (r) { return r.budget.stretch || r.budget.stretch2; });
    // ご予算の近くに何も無いときは、点の高い順ではなく価格の近いものから（2026-10-09 納得チェック:
    // 予算3万円で電動を選んだ人に、14万円の車体が本命になっていた）
    if (!main.length && scored.length) {
      var minPi = Math.min.apply(null, scored.map(function (r) { return r.p.pi; }));
      main = scored.filter(function (r) { return r.p.pi <= minPi * 1.3; });
    }
    var used = {}, usedBase = {};
    var take = function (r, role, note) { used[r.p.h] = 1; usedBase[r.p.base] = 1; return { p: r.p, s: r.s, why: r.why, care: r.care, budget: r.budget, near: r.near, bad: r.bad || 0, role: role, note: note || '' }; };
    var free = function (r) { return !used[r.p.h] && !usedBase[r.p.base]; };
    var out = [];
    if (!main.length) return out;

    // 本命: 在庫が2店舗以上ある中で一番合うもの（点差が大きければ1店舗でも本命）
    // 答えに反するところ（bad）のない車体を本命に。点差15以内なら bad の無いほうを上に（round-2 P4: 変速なしのトラック車）
    // 見た目を一番に大事にする人には、見た目の理由が言える車体を先に（round-5 P7「3台とも見た目の説明が無い」）
    // 思い描いている形を答えた人の本命は、その形から選ぶ（2026-10-09 選択肢の精査:
    // 「ママチャリ」と答えたのに見た目の好みでクロスバイクが本命になり、途中の候補とも食い違っていた）
    var imgFit = function (r) { var img = a.image; return !img || img === 'undecided' || imageMatch(img, r.p.fam) || (img === 'town' && /cross|mini|city/.test(r.p.fam)); };
    var hm = main.filter(imgFit);
    if (!hm.some(function (r) { return !r.bad; })) hm = main;
    // 通学車を思い描いた人の本命は27インチから（2026-10-09 納得チェック: 24インチのシティ車が本命）
    if (a.image === 'school') {
      var s27 = hm.filter(function (r) { return !r.bad && /27インチ/.test(r.p.ts || ''); });
      if (s27.length) hm = s27;
    }
    // エレベーターで運ぶ人は、形を決めていなければ折りたたみ・小径車から本命を選ぶ
    // 車や電車に載せたい人は折りたたみから（2026-10-09 納得チェック: 車に積みたいのにツーリング車が本命）
    if ((a.place === 'elev' || a.place === 'car') && (!a.image || a.image === 'undecided')) {
      var small = hm.filter(function (r) { return !r.bad && (a.place === 'car' ? r.p.fo : (r.p.fo || r.p.fam === 'mini' || r.p.fam === 'e-mini')); });
      if (small.length) hm = small;
    }
    var clean = a.priorities[0] === 'design' ? hm.filter(function (r) { return !r.bad && lookFit(r, a, true); }) : [];
    if (!clean.length) clean = hm.filter(function (r) { return !r.bad && lookOK(r); });
    if (!clean.length) clean = hm.filter(function (r) { return !r.bad; });
    // 見た目を大事にする人には、見た目を言える車体を本命に（round-3 P7「色も形も分からないものが本命」）
    var tol = (a.priorities.indexOf('design') >= 0 || a.style === 'unique') ? 20 : 15;
    // 答えに2つ以上反する車体は、点が高くても本命にしない（2026-10-09 納得チェック: 車に積む・スカートなのに重い電動が本命）
    var top = clean.length && (clean[0].s >= hm[0].s - tol || (hm[0].bad || 0) >= 2) ? clean[0] : hm[0];
    var base = top.bad ? hm : clean;
    // 行けるあたりに在庫があるものを先に（地域・位置情報があるとき）
    var full0 = function (r) { return r.why.some(function (w) { return w.id === 'image' && w.w >= 30; }); };
    var kin = function (r) { return sameKind(r.p, top.p) && (!full0(top) || full0(r)); };
    var multi = base.filter(function (r) { return kin(r) && (r.p.st || 0) >= 2 && (r.near == null || r.near >= 1); })[0]
      || base.filter(function (r) { return kin(r) && (r.p.st || 0) >= 2; })[0];
    // 在庫のある店舗が多いほうを本命にするのは、点がほぼ同じとき（3点差まで）だけ
    var hon = multi && multi.s >= top.s - 3 ? multi : top;
    out.push(take(hon, 'honmei'));

    var hp = hon.p.pi;
    // 本命が思い描いた形そのもの（通学車なら27インチ）なら、比べる候補もそろえる
    var full = function (r) { return r.why.some(function (w) { return w.id === 'image' && w.w >= 30; }); };
    var honFull = full(hon);
    var cands = function (fn) { return main.concat(scored).filter(function (r, i, arr) { return arr.indexOf(r) === i && free(r) && fn(r); }); };

    // 比べる候補1: 同じ系統で、価格をおさえたもの
    var save = cands(function (r) { return r.budget.ok && !r.bad && lookOK(r) && (!honFull || full(r)) && r.p.pi <= hp * 0.88 && r.s >= hon.s * 0.6 && sameKind(r.p, hon.p) && (!hon.p.ks || r.p.ks >= hon.p.ks); })[0];
    // 比べる候補2: 少し足すと良くなるもの（答えに効く違いがあるときだけ・round-1 P8「通勤に未舗装は足す理由にならない」）
    var up = cands(function (r) { return r.p.pi > hp * 1.08 && !r.bad && (!honFull || full(r)) && (!hon.p.ks || r.p.ks >= hon.p.ks) && lookOK(r) && (r.budget.ok || r.budget.stretch || (a.budget === 'q')) && r.s >= hon.s * 0.6 && sameKind(r.p, hon.p) && upgradeFacts(hon.p, r.p, a).length; })[0];
    // 本命がご予算より安いときは、ご予算の中の同じ系統も並べる（round-3 P8「16〜20万と言ったのに、その価格帯が出てこない」）
    var inbud = false;
    if (!up && hon.budget.under && a.priority !== 'price') inbud = !!(up = cands(function (r) { return r.budget.inside && !r.bad && lookOK(r) && (!honFull || full(r)) && sameKind(r.p, hon.p) && r.s >= hon.s * 0.6 && (!hon.p.ks || r.p.ks >= hon.p.ks); })[0]);
    // 足すほうが無いとき・おさえるほうが無いときは、同じ系統の別メーカーで比べる
    // 人と被らないものを、と答えた人には、どこにでもある定番を比べる候補にしない（round-5 P10「37店舗にあるTB1」）
    var uniq = function (r) { var b = brands[r.p.v] || {}; return a.style !== 'unique' || b.spec || (b.avgSt || 99) <= 3 || (r.p.st || 0) <= 5; };
    var rival = cands(function (r) { return uniq(r) && r.budget.ok && !r.bad && lookOK(r) && (!honFull || full(r)) && r.p.v !== hon.p.v && sameKind(r.p, hon.p) && r.s >= hon.s * 0.6; })[0];

    if (a.priority === 'price') {
      if (save) out.push(take(save, 'save'));
      if (rival && free(rival)) out.push(take(rival, 'rival'));
    } else {
      if (up) out.push(inbud ? take(up, 'inbud') : take(up, 'up', upgradeFacts(hon.p, up.p, a).join('・')));
      if (save) out.push(take(save, 'save'));
      if (out.length < 3 && rival && free(rival)) out.push(take(rival, 'rival'));
    }
    // まだ2台目が無いなら、点数順で次（同じ車種の色違いは除く）
    if (out.length < 3) {
      var next = cands(function (r) { return uniq(r) && r.budget.ok && !r.bad && lookOK(r) && (!a.image || a.image === 'undecided' || imageMatch(a.image, r.p.fam)); });
      for (var i = 0; i < next.length && out.length < 3; i++) if (free(next[i])) out.push(take(next[i], out.some(function (o) { return o.role === 'rival'; }) ? 'rival2' : 'rival'));
    }
    // 見た目の手がかりが無い車体しか残っていなくても、2台では比べられない。色は店舗で、の注意つきで並べる
    if (out.length < 3) {
      var rest = cands(function (r) { return r.budget.ok && !r.bad && (!wNeed || !!(r.p.wkg || r.p.wt)) && sameKind(r.p, hon.p) && (!honFull || full(r)) && r.s >= hon.s * 0.6; });
      for (var j = 0; j < rest.length && out.length < 3; j++) if (free(rest[j])) out.push(take(rest[j], out.some(function (o) { return o.role === 'rival'; }) ? 'rival2' : 'rival'));
    }
    // それでも1台きりなら、重さ・見た目の手がかりが無いものも並べる（注意は care が添える）。
    // 合う車体が100台以上あるのに本命1台だけ、を作らない（2026-10-09 納得チェック）
    if (out.length < 3) {
      var last = cands(function (r) { return r.budget.ok && (r.bad || 0) <= (hon.bad || 0) && (!a.image || a.image === 'undecided' || imageMatch(a.image, r.p.fam)) && r.s >= hon.s * 0.5; });
      for (var k2 = 0; k2 < last.length && out.length < 3; k2++) if (free(last[k2])) out.push(take(last[k2], out.some(function (o) { return o.role === 'rival'; }) ? 'rival2' : 'rival'));
    }

    // ご予算を少し超える一台を、参考に1台だけ添える（2026-10-09 本間さん「予算に収まるの中心で、少しオーバーのものも
    // 参考までに見せていくとよい」）。価格をおさえたい人には出さない
    if (a.priority !== 'price' && BUDGET[a.budget] && !out.some(function (o) { return o.budget.stretch || o.budget.stretch2; })) {
      var over = cands(function (r) { return r.budget.stretch && !r.bad && lookOK(r) && (!honFull || full(r)) && sameKind(r.p, hon.p) && r.s >= hon.s * 0.6; })[0];
      if (over) out.push(take(over, 'over'));
    }
    // 別の選び方: 思い描いているもの・本命とは違う系統で、答えにより強く応えるもの
    var alt = altPick(scored, a, hon, free);
    // 「別の選び方」が、すでに出した一台と同じメーカー・同じ形・同じ変速なら別とは言えない（round-4 P9）
    if (alt && out.some(function (o) { return o.p.v === alt.r.p.v && o.p.fam === alt.r.p.fam && o.p.gear === alt.r.p.gear && (o.p.cs || '') === (alt.r.p.cs || ''); })) alt = null;
    // 人と被らないものを、と答えた人に、どこにでもある定番を「別の選び方」で出さない（round-4 P10）
    if (alt && a.style === 'unique' && !((brands[alt.r.p.v] || {}).spec || ((brands[alt.r.p.v] || {}).avgSt || 99) <= 3)) alt = null;
    if (alt) out.push(take(alt.r, 'alt', alt.why));

    // 専門ブランドの枠（人と被らない・長く・育てる・見た目、または予算に余裕のある人だけ）
    var wantsDisco = a.rider !== 'child' && (a.style === 'unique' || a.style === 'long' || a.style === 'custom' || a.priority === 'design' || a.budget === 'q' || a.budget === 'b35' || a.budget === 'b50');
    if (wantsDisco && a.rider !== 'kidscarry') {
      var vend = {}; out.forEach(function (o) { vend[o.p.v] = 1; });
      var d = scored.filter(function (r) {
        var b = brands[r.p.v] || {};
        if (!b.spec || vend[r.p.v] || !free(r) || !r.p.img || r.bad || !lookFit(r, a, true)) return false;
        if (a.image && a.image !== 'undecided' && !imageMatch(a.image, r.p.fam) && !(a.image === 'town' && /cross|mini|city/.test(r.p.fam))) return false;
        if (!(r.budget.ok || r.budget.stretch)) return false;
        return r.s >= hon.s * 0.45;
      }).sort(function (x, y) { var dx = (brands[x.p.v] || {}).desc ? 1 : 0, dy = (brands[y.p.v] || {}).desc ? 1 : 0; return (dy - dx) || (y.s - x.s); })[0];
      if (d) out.push(take(d, 'disco'));
    }
    return out;
  }
  function kindGroup(f) { return f.indexOf('e-') === 0 ? (f === 'e-sport' ? 'sport' : f === 'e-kids' ? 'ekids' : 'ecity') : (f === 'road' || f === 'cross' || f === 'mtb') ? f : f === 'mini' ? 'mini' : f; }
  function sameKind(p, q) { return kindGroup(p.fam) === kindGroup(q.fam) || (p.fam === q.fam); }
  /* 「あと◯円足すと何が変わるか」— データで言える違いだけ */
  function upgradeFacts(base, up, a) {
    var f = [];
    a = a || {};
    var wRank = { '10kg未満': 0, '10〜15kg': 1, '15〜20kg': 2, '20kg以上': 3 };
    var hills = has(a, 'hill') || a.dist === 'mid' || a.dist === 'long' || uses(a, 'ride') || uses(a, 'fitness') || uses(a, 'commute');
    if (base.wkg && up.wkg && up.wkg < base.wkg - 0.5) f.push('重さが' + up.wkg + 'kg（' + (Math.round((base.wkg - up.wkg) * 10) / 10) + 'kg軽く）に');
    else if (base.wt && up.wt && wRank[up.wt] < wRank[base.wt]) f.push('重さが' + up.wt + 'に');
    if (hills && base.gear === 'none' && (up.gear === 'ext' || up.gear === 'int')) f.push('変速つきに');
    if ((has(a, 'rain') || a.priority === 'tough') && base.gear === 'ext' && up.gear === 'int') f.push('内装変速に');
    if (has(a, 'night') && !base.li && up.li) f.push('オートライトつきに');
    // シティ車は見た目のタグに泥よけが無くても付いていることが多い。タグの差だけで「泥よけ付きに」と言わない（round-2 P9）
    if (has(a, 'rain') && base.sty.length && base.fam !== 'city' && !/^e-(city|kids)$/.test(base.fam) && base.sty.indexOf('フェンダーあり') < 0 && up.sty.indexOf('フェンダーあり') >= 0) f.push('泥よけ付きに');
    if (a.kids_count === '2' && base.cs !== 'both' && up.cs === 'both') f.push('前とうしろ両方の席に対応した車体に');
    if ((a.style === 'long' || a.priority === 'long' || has(a, 'tour') || a.look === 'classic') && !STEEL_RE.test(base.frm || '') && STEEL_RE.test(up.frm || '') && base.fam !== 'city') f.push('フレームがクロモリ（鉄）に');
    if ((has(a, 'dirt') || has(a, 'tour')) && (up.srf || []).indexOf('未舗装も可') >= 0 && (base.srf || []).indexOf('未舗装も可') < 0) f.push('未舗装の道も走れる作りに');
    if (a.look && LOOK_TAGS[a.look]) {
      var hb = base.sty.filter(function (t) { return LOOK_TAGS[a.look].indexOf(t) >= 0; }).length;
      var hu = up.sty.filter(function (t) { return LOOK_TAGS[a.look].indexOf(t) >= 0; });
      if (hu.length >= 2 && hu.length > hb + 1 && a.priority === 'design') f.push('見た目がお好みの「' + hu.slice(0, 2).join('・') + '」寄りに');
    }
    return f;
  }

  function altPick(scored, a, hon, free) {
    var lowNeed = has(a, 'skirt') || has(a, 'knee');
    var lookOK = function (r) { return lookFit(r, a, true) && (!lowNeed || lowFrame(r.p)); };
    if (a.rider === 'child') {
      var bigger = scored.filter(function (r) { return free(r) && r.p.ks && hon.p.ks && r.p.ks > hon.p.ks && r.budget.ok && r.p.v !== hon.p.v; })[0];
      if (bigger) return { r: bigger, why: '少し大きい' + bigger.p.ks + 'インチ。いまの身長でも乗れる範囲で、長く乗れる大きさです。どちらが合うかは店舗でまたがって比べてください' };
      var other = scored.filter(function (r) { return free(r) && r.p.v !== hon.p.v && r.budget.ok; })[0];
      return other ? { r: other, why: '別のメーカーの一台です。色や形を本人と見比べてください' } : null;
    }
    var hf = hon.p.fam, img = a.image;
    var rule = null;
    var budgetLoose = function (r) { return r.budget.ok || r.budget.stretch || r.budget.stretch2; };
    // 坂・長距離・ラクさ → 電動（電動以外を選んでいないとき）
    if (!hon.p.el && a.electric !== 'no' && (has(a, 'hill') || a.dist === 'long' || a.priority === 'easy' || has(a, 'load'))) {
      rule = { fn: function (r) { return r.p.el && r.p.fam !== 'e-kids' && budgetLoose(r) && (a.place !== 'carry'); },
        why: (has(a, 'hill') ? '坂道がある' : a.dist === 'long' ? '片道10km以上' : has(a, 'load') ? '荷物が多い' : 'ラクに走りたい') + 'とのことなので、電動アシストという選び方もあります。' + (img && img !== 'undecided' && img !== 'ebike' ? '思い描いていた' + IMAGE_NAME[img] + 'とは違いますが、' : '') + '上り坂とこぎ出しが軽くなります' };
    } else if (hon.p.el && (!a.electric || a.electric === 'unsure') && a.rider === 'self') {
      rule = { allowBad: 1, fn: function (r) { return !r.p.el && r.budget.ok && (r.p.fam === hf.replace('e-', '') || r.p.fam === 'city' || r.p.fam === 'mini'); },
        why: '電動にするか決めていないなら、電動ではない一台とも比べてください。モーターとバッテリーが無い分、車体が軽く、価格もおさえられます' };
    } else if (a.place === 'carry' && !hon.p.fo) {
      rule = { fn: function (r) { return r.p.fo && !r.p.el && budgetLoose(r); }, why: '運び上げるとのことなので、たためる一台も候補です。たたむとエレベーターにも収まります' };
    } else if (img === 'road' && (uses(a, 'commute') || uses(a, 'shopping') || a.dist === 'short' || has(a, 'load'))) {
      rule = { fn: function (r) { return r.p.fam === 'cross' && r.budget.ok; }, why: 'ロードバイクを思い描いていましたが、' + (uses(a, 'commute') ? '通勤・通学' : '街なかの用事') + 'にも使うなら、まっすぐなハンドルのクロスバイクも候補です。前かがみがゆるく、信号の多い道で扱いやすい形です' };
    } else if (img === 'school') {
      var gname = { ext: '外装変速', int: '内装変速', none: '変速なし' };
      rule = { fn: function (r) { return r.p.fam === 'city' && /27インチ/.test(r.p.ts || '') && r.p.gear && r.p.gear !== hon.p.gear && r.budget.ok; },
        whyFn: function (r) { return '同じ27インチの通学車で、本命は' + (gname[hon.p.gear] || '') + '、こちらは' + gname[r.p.gear] + 'です。' + (r.p.gear === 'int' ? '内装変速は雨や泥に強く、手入れが少なくて済みます' : r.p.gear === 'ext' ? '外装変速は段数が多く、坂や向かい風で細かくギアを選べます' : '変速なしは部品が少なく、価格と手入れをおさえられます'); } };
    } else if (img === 'town') {
      rule = { allowBad: 0, fn: function (r) { return /cross|mini|city/.test(r.p.fam) && kindGroup(r.p.fam) !== kindGroup(hf) && !r.p.el && r.budget.ok; },
        whyFn: function (r) { return '同じ街乗りでも、' + FAMILY_NAME[r.p.fam] + 'という形もあります。' + (r.p.fam === 'mini' ? '車輪が小さく、こぎ出しが軽くて小回りがききます' : r.p.fam === 'cross' ? '車輪が大きく、一度にこげる距離がのびます' : 'カゴや泥よけを付けて、普段の足にも使えます'); } };
    } else if (img === 'cross' && (uses(a, 'ride') || a.priority === 'speed' || has(a, 'tour'))) {
      rule = { fn: function (r) { return (has(a, 'tour') ? ((r.p.srf || []).indexOf('未舗装も可') >= 0 || STEEL_RE.test(r.p.frm || '')) && r.p.fam !== 'cross' : r.p.fam === 'road') && budgetLoose(r); },
        why: has(a, 'tour') ? '旅もしてみたいとのことなので、荷物を積んで遠くへ行く作りの一台も見てください' : '休日に遠くまで走るなら、ロードバイクという選び方もあります。前に体を倒した姿勢で、長い距離を速く走れます' };
    } else if (img === 'city' && a.electric !== 'yes' && (a.priority === 'speed' || a.dist === 'mid' || a.dist === 'long') && a.rider === 'self') {
      rule = { fn: function (r) { return r.p.fam === 'cross' && r.budget.ok && r.p.li; }, why: '通う距離が長めなら、クロスバイクで軽く走るという選び方もあります' };
    } else if (img === 'tour') {
      rule = { allowBad: 1, fn: function (r) { return r.p.v !== hon.p.v && (r.p.fam === 'tour' || STEEL_RE.test(r.p.frm || '')) && !r.p.el && r.p.pi >= 50000 && r.p.img; },
        whyFn: function (r) { return hon.p.v + 'のほかにも、' + (STEEL_RE.test(r.p.frm || '') ? '鉄のフレームで' : '') + '遠くへ行ける作りの一台があります。' + (r.p.pi < hon.p.pi * 0.6 ? '価格をおさえて旅を始めるなら、こちらも候補です' : 'メーカーが違うと乗った感じも変わるので、店舗で比べてください'); } };
    } else if (img === 'mini' && a.place === 'carry') {
      rule = { fn: function (r) { return r.p.fam === 'mini' && !!r.p.fo !== !!hon.p.fo && !r.p.el && budgetLoose(r); },
        whyFn: function (r) { return r.p.fo ? '同じ小さい車輪で、こちらは折りたためる一台です。たたむと階段やエレベーターで運びやすくなります' : '同じ小さい車輪で、こちらは折りたたまない一台です。たたむ仕組みが無い分、車体がしっかりしていて軽いものもあります。持ち上げて比べてください'; } };
    } else if (img === 'mini' && !has(a, 'load') && a.place !== 'carry') {
      rule = { fn: function (r) { return r.p.fam === 'cross' && r.budget.ok; }, why: '持ち運ばないなら、車輪の大きいクロスバイクで一度にこぐ距離をのばす選び方もあります' };
    } else if (a.rider === 'kidscarry') {
      var seat = { front: '前の席が付いた形', rear: 'うしろの席が付いた形', both: '前とうしろ両方に対応した車体' };
      rule = { fn: function (r) { return r.budget.ok && r.p.cs && r.p.cs !== 'none' && r.p.cs !== hon.p.cs; },
        whyFn: function (r) { return '本命は' + (seat[hon.p.cs] || '子乗せの車体') + '、こちらは' + seat[r.p.cs] + 'です。' + (r.p.v !== hon.p.v ? 'メーカーも違うので、' : '') + '席の位置と乗せ降ろしのしやすさを、店舗で並べて比べてください'; } };
    }
    if (rule) {
      var hit = scored.filter(function (r) { return free(r) && rule.fn(r) && lookOK(r) && (r.bad || 0) <= (rule.allowBad || 0); })[0];
      if (hit) return { r: hit, why: rule.whyFn ? rule.whyFn(hit) : rule.why };
    }
    // 決まっていない人・ほかに無いとき: 本命と違う系統で一番合うもの
    var imgOK = function (r) { return !img || img === 'undecided' || imageMatch(img, r.p.fam); };
    var diff = scored.filter(function (r) { return free(r) && !r.bad && r.p.img && imgOK(r) && lookOK(r) && kindGroup(r.p.fam) !== kindGroup(hf) && r.budget.ok && r.s >= hon.s * 0.5; })[0];
    if (diff) return { r: diff, why: 'お答えには、' + FAMILY_NAME[diff.p.fam] + 'も合います。形が違うと乗った感じも変わるので、店舗で並べて比べてください' };
    return null;
  }

  /* ───────────── ストーリー（結果の組み立て方） ─────────────
     答えの組み合わせで5つの型に分け、見出し・役の名前・店舗で確かめること・次の一歩を変える */
  function storyOf(a) {
    if (a.rider === 'child') return 'kids';
    if (a.rider === 'kidscarry') return 'family';
    if (a.style === 'unique' || a.priority === 'design' || a.image === 'town') return 'unique';
    if (a.priority === 'easy' && a.use === 'commute') return 'daily';
    if (a.use === 'ride' || a.use === 'fitness' || a.image === 'road' || a.image === 'tour' || a.priority === 'speed' || a.style === 'custom') return 'hobby';
    if (a.image === 'school') return 'school';
    if (a.style === 'long' || a.priority === 'long') return 'choice';
    return 'daily';
  }
  var ROLE = {
    honmei: { kids: 'いまのお子さんに、まずこの一台', family: '送り迎えの本命', hobby: '本命', choice: '本命', daily: '本命', unique: '本命', school: '通学の本命' },
    up: 'もう少し足せるなら',
    over: 'ご予算を少し超えますが、参考に',
    inbud: 'ご予算の価格帯なら',
    save: '価格をおさえるなら',
    rival: '比べてほしい、もう一台',
    rival2: 'こちらも比べてみてください',
    alt: '別の選び方',
    disco: '知っておくと、選び方が広がる一台',
  };
  function roleName(role, story) { var r = ROLE[role]; return typeof r === 'string' ? r : r[story]; }

  /* お話をまとめると（答えを店員の言葉で言い直す） */
  function recap(a) {
    var s = [];
    if (a.rider === 'child') {
      s.push('お子さんの身長は' + label('child_height', a.child_height, a).replace(/（.*?）/, '') + '。');
      if (a.child_use) s.push({ first: 'はじめての自転車で、乗る練習から。', play: '公園や友だちの家へ乗っていく。', far: '坂のある道や、少し遠くまで乗る。' }[a.child_use]);
      if (a.child_look) s.push({ cool: 'かっこいい形が好き。', cute: 'かわいい色が好き。', simple: 'シンプルで、きょうだいでも使えるといい。' }[a.child_look]);
      if (a.budget) s.push('ご予算は' + label('budget', a.budget, a) + '。');
      return s.join('');
    }
    if (a.rider === 'kidscarry') s.push((a.kids_count === '2' ? '2人のお子さんを乗せて' : 'お子さんを乗せて') + '、' + ({ short: '近所', mid: '3〜10km', long: '10km以上' }[a.dist] || '') + (a.dist ? 'を走る。' : '走る。'));
    else {
      if (a.image && a.image !== 'undecided') s.push('思い描いているのは' + IMAGE_NAME[a.image] + '。');
      if (a.mood) s.push('乗っている自分は「' + label('mood', a.mood, a) + '」。');
      if (a.uses.length) s.push(a.uses.map(function (u) { return USE_SAY[u]; }).join('と') + (a.dist === 'short' ? 'に、近所を走る。' : a.dist === 'mid' ? 'に、片道3〜10km。' : a.dist === 'long' ? 'に、片道10km以上。' : 'に使う。'));
    }
    var c = [];
    if (has(a, 'hill')) c.push('坂道がある');
    if (has(a, 'night')) c.push('暗くなってからも乗る');
    if (has(a, 'rain')) c.push('雨の日も乗る');
    if (has(a, 'load')) c.push('荷物が多い');
    if (has(a, 'knee')) c.push('またぎやすい低いフレームがいい');
    if (has(a, 'skirt')) c.push('スカートで乗りたい');
    if (has(a, 'suit')) c.push('スーツ・革靴で乗りたい');
    if (has(a, 'tour')) c.push('いつか荷物を積んで旅もしたい');
    if (has(a, 'dirt')) c.push('砂利道も走りたい');
    if (c.length) s.push(c.join('、') + '。');
    if (a.place === 'carry') s.push('部屋まで階段で運び上げる。');
    else if (a.place === 'elev') s.push('エレベーターで部屋まで運ぶ。');
    else if (a.place === 'car') s.push('車や電車に載せたい。');
    else if (a.place === 'indoor') s.push('室内に置く。');
    else if (a.place === 'outdoor') s.push('置き場所は屋外。');
    if (a.electric === 'unsure') s.push('電動にするかは、重さや充電が気になって迷っている。');
    if (a.height) s.push('身長は' + label('height', a.height, a) + '。');
    if (AREA[a.area]) s.push('お店に行くなら' + AREA[a.area].n + '。');
    if (a.look) s.push('見た目は「' + label('look', a.look, a) + '」が好き。');
    if (a.style && a.style !== 'standard') s.push({ long: '気に入った一台を直しながら長く乗りたい。', unique: '人と被らない一台がいい。', custom: '部品を替えて育てたい。' }[a.style]);
    if (a.budget && BUDGET[a.budget]) s.push('ご予算は' + label('budget', a.budget, a) + '、');
    else if (a.budget === 'q') s.push('良いものなら予算は考える、');
    var PRN = { easy: 'ラクに走れること', light: '軽さ', price: '価格', tough: '丈夫さ', design: '見た目', speed: '走る楽しさ', long: '長く使えること', safe: '子どもを乗せたときの乗りやすさ' };
    var pr = (a.priorities || []).map(function (x) { return PRN[x]; }).filter(Boolean).join('と');
    if (pr) s.push('決め手は' + pr + '。');
    else if (s.length && /、$/.test(s[s.length - 1])) s[s.length - 1] = s[s.length - 1].replace(/、$/, '。');
    var tm = { soon: '2週間以内には乗り始めたい。', month: '1か月以内に決めたい。', later: '急いではいない。' }[a.timing];
    if (tm) s.push(tm);
    return s.join('');
  }

  /* 選ぶときに見たこと（重い need から3〜4つ。実際に絞り込み・採点したことだけを書く） */
  function criteria(a, N, counts, picks) {
    var c = [];
    if (a.rider === 'child') {
      c.push('身長に合う大きさのものだけ（適応身長かタイヤの大きさで判断）');
      if (a.child_use === 'far') c.push('坂のある道を走るので、変速のあるもの');
      if (a.child_use === 'first') c.push('はじめてなので、キックバイクや補助輪から始められるもの');
    } else {
      if (a.electric === 'yes') c.push('電動アシストの中から');
      else if (a.electric === 'no') c.push('電動ではないものから');
      if (a.rider === 'kidscarry') c.push('子どもを乗せられると分かっている車体だけ');
      if (a.image && a.image !== 'undecided' && a.image !== 'ebike') c.push('思い描いている' + IMAGE_NAME[a.image] + 'を中心に');
      // 電動を選んだ人に「坂なので電動か変速つき」は重ねない（round-1 P3・P8）
      var skip = ['image', 'el', 'height', 'kage', 'kids2'];
      if (a.electric === 'yes') skip.push('hill', 'pri');
      if (a.priority === 'easy' && has(a, 'hill')) skip.push('pri');
      if (a.priority === 'design' && a.style === 'unique') skip.push('pri');
      var heavy = N.filter(function (n) { return n.w >= 10 && skip.indexOf(n.id) < 0 && !(n.id === 'pri' && a.electric === 'yes' && a.priority === 'easy'); })
        .sort(function (x, y) { return y.w - x.w; }).slice(0, 5);
      heavy.forEach(function (n) { var t = n.crit || critOf(n.id.replace(/\d$/, ''), a, n); if (t && c.indexOf(t) < 0) c.push(t); });
      if (a.height) c.push('身長' + label('height', a.height, a) + '。適応身長が公表されている車体は、その範囲に入るものだけ（公表の無いものは店舗でまたがって確かめてください）');
      if (AREA[a.area]) c.push('同じくらい合うなら、' + AREA[a.area].n + 'の店舗に在庫があるものを先に');
    }
    var over = (picks || []).some(function (r) { return r.budget && !r.budget.ok; });
    var under = (picks || []).filter(function (r) { return r.budget && r.budget.under; }).length;
    if (a.budget && BUDGET[a.budget]) c.push('ご予算' + label('budget', a.budget, a) + 'の中で' + (over ? '（「足せるなら」の一台だけ少し上）' : '')
      + (under >= 2 ? '。この価格帯で条件に合う自転車が少ないため、少し下の価格からも選んでいます' : ''));
    return c;
  }

  function critOf(id, a, n) {
    var pri = { easy: 'ラクに走りたいので、電動か変速つきを優先', light: '軽さを大事にするので、重さ15kgまでを優先', price: '価格をおさえたいので、予算の中でも安いものを上に', tough: '手間を少なくしたいので、内装変速やシンプルな作りを優先', design: '見た目を大事にするので、個性のあるブランドを優先', speed: '走る楽しさを大事にするので、ロードバイク・クロスバイクを優先', long: '長く使いたいので、鉄のフレームや内装変速を優先', safe: '乗せ降ろしのしやすい20インチを優先' };
    var place = { carry: '階段で運び上げるので、重さが分かっていて軽いもの・折りたたみだけ' + (a.electric === 'no' ? '' : '（電動は外す方向）'), elev: 'エレベーターで運ぶので、折りたたみや取り回しの軽いものを少し優先', car: '車や電車に載せたいので、折りたためるものを優先', indoor: '室内に置くので、場所をとらないものを少し優先' };
    var style = { standard: '定番がいいので、多くの店舗で扱う車種を優先', long: '直しながら長く乗るので、鉄のフレームや長く続くブランドを優先', unique: '人と被らないものがいいので、取り扱う店舗の少ないブランドを優先', custom: '自分好みに育てたいので、部品を替えやすいスポーツ車を優先' };
    var m = {
      use: 'メーカーが「' + (a.uses || []).map(function (u) { return USE_TAG[u]; }).filter(function (x, i, arr) { return arr.indexOf(x) === i; }).join('」「') + '」向けとしているものを優先',
      kids: a.kids_count === '1' ? 'お子さんを乗せる席のあるものを優先' : '2人乗せ（前とうしろ）に対応した車体を優先',
      dist: a.dist === 'long' ? '片道10km以上なので、変速か電動のあるものだけ' : a.dist === 'mid' ? '3〜10km走るので、変速のあるものを優先' : '近所が中心なので、手入れの少ない作りを少し優先',
      hill: '坂道があるので、電動か変速つきを優先',
      night: '暗くなってからも乗るので、オートライトを優先',
      rain: '雨の日も乗るので、内装変速や泥よけのあるものを優先',
      load: '荷物が多いので、カゴや荷台を付けやすい形を優先',
      knee: 'またぎやすさを大事にするので、フレームの低い形を優先',
      skirt: 'スカートで乗るので、フレームの低い形を優先',
      suit: 'スーツで乗るので、泥よけ付きや前かがみになりすぎない形を優先',
      esport: '車輪の大きいスポーツタイプの電動を優先',
      tour: '旅もしたいので、未舗装も走れる作りや鉄のフレームを優先',
      dirt: '砂利道も走るので、太いタイヤの作りを優先',
      place: place[a.place] || '',
      pri: pri[n && n.id === 'pri2' ? a.priorities[1] : a.priority] || '',
      look: '見た目の好み（' + label('look', a.look, a) + '）に近いものを優先',
      style: style[a.style] || '',
      size: '身長に合う大きさだけ（適応身長かタイヤの大きさで判断）',
    };
    return m[id] || '';
  }

  /* 店舗で確かめること（答えから） */
  function checklist(a, picks) {
    var c = [];
    if (a.rider === 'child') {
      c.push('お子さんにまたがってもらい、両足のつま先が地面に届くか');
      c.push('ブレーキのレバーに、お子さんの指が届くか');
      if (a.child_look) c.push('在庫のある色（お子さんと一緒に選べます）');
      if (a.child_use === 'far') c.push('変速の切り替えを、お子さんが自分でできるか');
      return c;
    }
    c.push('またがって、足のつき方とハンドルまでの距離');
    if (a.rider === 'kidscarry') { c.push('チャイルドシートの高さと、乗せ降ろしのしやすさ'); c.push('スタンドを立てるときの重さ'); }
    if (a.place === 'carry' || a.priority === 'light') c.push('実際に持ち上げたときの重さ');
    if (a.place === 'elev') c.push('車体の長さ（エレベーターに立てて載せられるか）');
    if (picks.some(function (r) { return r.p.el; })) c.push('バッテリーの外し方と充電のしかた（1回の充電で走れる距離もスタッフに）');
    if (has(a, 'night')) c.push('ライトの点き方（ライトの記載が無い車体は、乗り出しに要るライトも一緒に）');
    if (has(a, 'rain')) c.push('泥よけの有無と、レインカバーやかさ立ての付けやすさ');
    if ((picks[0].p.gear === 'ext' || picks[0].p.gear === 'int') && a.rider !== 'kidscarry') c.push('変速の段数と操作のしかた');
    if (picks.some(function (r) { return /cross|road|tour|mtb/.test(r.p.fam); })) c.push('ライト・カギ・スタンドが別売りの車体もあるので、乗り出しに要るものと合計の金額');
    if (a.place === 'outdoor') c.push('屋外に置くので、カギ（2つ目のカギ）とカバーのこと');
    if (a.look || a.child_look === 'cute' || a.child_look === 'cool' || a.priority === 'design') c.push('在庫のある色（色ごとに置いている店舗が違うことがあります）');
    if (a.place === 'car') c.push('たたみ方と、たたんだときの大きさ');
    if (a.electric === 'unsure') c.push('電動と電動でないものを押し比べて、重さの違い');
    if (a.image === 'school') c.push('学校で決まっている条件（ライト・カゴ・ステッカーなど）と防犯登録');
    return c;
  }

  function km(aLat, aLng, bLat, bLng) {
    var R = 6371, d2r = Math.PI / 180;
    var dLat = (bLat - aLat) * d2r, dLng = (bLng - aLng) * d2r;
    var s = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(aLat * d2r) * Math.cos(bLat * d2r) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return R * 2 * Math.atan2(Math.sqrt(s), Math.sqrt(1 - s));
  }
  var fmtKm = function (d) { return (d < 10 ? d.toFixed(1) : Math.round(d)) + 'km'; };
  var shortStore = function (n) { return String(n).replace('サイクルスポット', '').replace('ル・サイク', 'ル・サイク '); };

  /* 行けるあたりの目安の地点（位置情報を使わない人向け）。距離の数字は出さず、並び順だけに使う */
  var AREA = {
    te: { n: '東京23区の東側', lat: 35.71, lng: 139.81 },
    tw: { n: '東京23区の西側', lat: 35.675, lng: 139.645 },
    tm: { n: '東京の多摩地域', lat: 35.68, lng: 139.45 },
    kn: { n: '神奈川', lat: 35.50, lng: 139.58 },
    st: { n: '埼玉', lat: 35.89, lng: 139.63 },
    cb: { n: '千葉・茨城', lat: 35.70, lng: 140.02 },
    sz: { n: '静岡', lat: 35.10, lng: 138.86 },
  };
  var NEAR_KM = 15;
  /* 店舗がその地域に入るか。都県で分け、東京は経度で23区の東西と多摩に分ける（目安。round-2 P4・P10「近い順に別の地域が並ぶ」） */
  function inArea(st, code) {
    var pref = st[2] || '', lng = st[4];
    if (code === 'kn') return pref === '神奈川県';
    if (code === 'st') return pref === '埼玉県';
    if (code === 'cb') return pref === '千葉県' || pref === '茨城県';
    if (code === 'sz') return pref === '静岡県';
    // 東京は区の境で切ると「西側に大森」のようなずれが出る（round-3）。目安の地点から10km以内を「このあたり」とする
    if (pref !== '東京都' || !isFinite(lng) || !AREA[code]) return false;
    return km(AREA[code].lat, AREA[code].lng, st[3], lng) <= 10;
  }
  function isNear(st, geo) {
    if (!st || !geo) return false;
    if (geo.code) return inArea(st, geo.code);
    return isFinite(st[3]) && km(geo.lat, geo.lng, st[3], st[4]) <= NEAR_KM;
  }
  function nearCount(p, stores, geo) {
    if (!geo) return null;
    return (p.si || []).filter(function (i) { return isNear(stores[i], geo); }).length;
  }

  /* ───────────── 診断（答え → 結果） ───────────── */
  function diagnose(answers, data, text, opts) {
    opts = opts || {};
    var a = normalize(answers);
    var brands = data.brands || {};
    var all = prep(data.products || []);
    var tx = text || {};
    all.forEach(function (p) { var t = tx[p.h]; if (t && t.wkg) p.wkg = t.wkg; if (t && t.ec) p.ec = t.ec; });
    var pool = hardFilter(all, a);
    var N = needs(a, brands);
    var stores = data.stores || [];
    // 位置情報があればそれを、無ければ答えた地域の目安の地点を使う（地域は距離の数字を出さない）
    var geo = opts.geo || (AREA[a.area] ? { lat: AREA[a.area].lat, lng: AREA[a.area].lng, n: AREA[a.area].n, code: a.area, approx: true } : null);
    var scored = pool.map(function (p) { var r = score(p, a, N, brands, { stores: stores, geo: geo }); r.p = p; return r; })
      .sort(function (x, y) { return y.s - x.s || (y.p.st || 0) - (x.p.st || 0); });
    scored = dedupe(scored);
    var picks = pick(scored, a, brands);
    var story = storyOf(a);
    // 思い描いた形が本命にならなかったときは、黙って別の形を出さず、何とぶつかったかを言う（2026-10-09 選択肢の精査）
    var img = a.image && a.image !== 'undecided' ? a.image : '';
    var imgOK = function (r) { return !img || imageMatch(img, r.p.fam) || (img === 'town' && /cross|mini|city/.test(r.p.fam)); };
    var gap = '';
    if (img && picks[0] && !imgOK(picks[0])) {
      var same = scored.filter(imgOK), inb = same.filter(function (r) { return r.budget.ok; });
      var head = '思い描いていた' + IMAGE_NAME[img];
      if (!same.length) gap = head + 'で、ほかの答えに合うものは、いま扱っている自転車にありませんでした。';
      else if (!inb.length) gap = head + 'は、ご予算の中に扱っている自転車がありませんでした。';
      else {
        var cnt = {}, topAsk = '';
        inb.forEach(function (r) { (r.miss || []).forEach(function (k) { cnt[k] = (cnt[k] || 0) + 1; if (!topAsk || cnt[k] > cnt[topAsk]) topAsk = k; }); });
        gap = head + 'で' + (topAsk ? '「' + String(topAsk).replace(/[「」]/g, '') + '」にも合うもの' : 'ほかの答えにも合うもの') + 'は、いま扱っている自転車にありませんでした。';
      }
      gap += '答えに近い形から選んでいます。';
    }
    // ご予算の中に1台も無いのに、黙ってご予算の外を本命にしない（2026-10-14 ペルソナ点検: 電動・3〜5万円で9万円の電動が本命）
    if (picks[0] && BUDGET[a.budget] && !scored.some(function (r) { return r.budget.ok; })) {
      gap = 'ご予算' + label('budget', a.budget, a) + 'の中に、お答えに合う自転車は、いま扱っている中にありませんでした。ご予算より高いものも含めて、近いものを出しています。';
    }
    var html = render({ a: a, picks: picks, story: story, N: N, brands: brands, text: text || {}, stores: stores, gap: gap,
      counts: { total: all.filter(function (p) { return !p.demo && p.fam !== 'skip'; }).length, pool: pool.length, fit: scored.filter(function (r) { return r.budget.ok && !r.bad && imgOK(r); }).length }, geo: geo, realGeo: !!opts.geo, asof: opts.asof || '', share: opts.share || '' });
    return { a: a, picks: picks, story: story, html: html, pool: pool.length };
  }

  /* ───────────── 結果のHTML ───────────── */
  function roleLabel(r, story) {
    // 「足せるなら」と言いながら予算の中、を作らない（round-1 P5）
    if (r.role === 'up' && r.budget && (r.budget.inside || r.budget.under)) return 'ご予算の中で、もう一段上';
    return roleName(r.role, story);
  }
  /* 全部の提案に共通する理由（同じ文が4回並ぶのを防ぐ・round-1 P6・P8）。3台以上のときだけまとめる */
  function commonReasons(picks) {
    if (picks.length < 3) return [];
    var key = function (w) { return w.ask + '|' + w.f; };
    var first = picks[0].why.filter(function (w) { return !w.quiet && w.id !== 'budget' && w.id !== 'near'; });
    var c = first.filter(function (w) {
      return picks.every(function (r) { return r.why.some(function (x) { return key(x) === key(w); }); });
    });
    return c.length >= 2 ? c : [];
  }
  function askText(w) {
    return (w.asks || [w.ask]).map(function (x) { return '「' + esc(String(x).replace(/[「」]/g, '')) + '」'; }).join('');
  }
  function reasonsHTML(r, n, common, shownY, many) {
    var ck = {}; (common || []).forEach(function (w) { ck[w.ask + '|' + w.f] = 1; });
    var own = r.why.filter(function (w) { return !ck[w.ask + '|' + w.f]; });
    // この一台ならではの理由（前のカードで書いていない説明）を先に
    var fresh = function (w) { return !(shownY && shownY[w.f + '|' + w.y]); };
    own = own.filter(fresh).concat(own.filter(function (w) { return !fresh(w); }));
    var list = own.filter(function (w) { return !w.quiet || own.length < 2; }).slice(0, n);
    if (!list.length) list = r.why.filter(function (w) { return !w.quiet; }).slice(0, 2);
    if (!list.length) return '';
    var same = (common || []).length ? '<p class="cs-diag__same">本命と同じく、' + common.map(function (w) { return askText(w); }).join('') + 'にも当てはまります</p>' : '';
    return '<div class="cs-diag__because"><p class="cs-diag__because-title">' + (many || (common || []).length ? 'この一台をすすめる理由' : 'あなたにすすめる理由') + '</p><ul class="cs-diag__because-list">'
      + list.map(function (w) {
        // 前の自転車で同じ説明を書いたら、2台目からは事実だけにする（同じ文の繰り返しを防ぐ・round-2）
        var key = w.f + '|' + w.y, again = shownY && shownY[key];
        if (shownY) shownY[key] = 1;
        return '<li><span class="cs-diag__ask">' + askText(w) + '</span><span class="cs-diag__arrow" aria-hidden="true"> → </span>'
          + '<span class="cs-diag__fact"><strong>' + esc(w.f) + '</strong>' + (w.y && !again ? '。' + esc(w.y) : '') + '</span></li>';
      }).join('') + '</ul>' + same + '</div>';
  }
  var GEAR_NAME = { ext: '外装変速', int: '内装変速', none: '変速なし' };
  /* 種類の書き方。未舗装も走れるロードは「グラベル寄り」と添える（round-3 P4: ROVE をただのロードと書いた） */
  function kindText(p) {
    if (FAMILY_NAME[p.fam] === '自転車') return p.bt || '';
    if (p.fam === 'road' && (p.srf || []).indexOf('未舗装も可') >= 0) return 'ロードバイク（未舗装も走れるグラベル寄り）';
    // 変速の無いクロスバイクは街乗り向けの作り。「クロスバイク」だけだと感覚とずれる（round-5 P10）
    if (p.fam === 'cross' && p.gear === 'none') return 'クロスバイク（変速なし・街乗り向け）';
    return FAMILY_NAME[p.fam];
  }
  function weightText(p) { return p.wkg ? p.wkg + 'kg' : (p.wt || ''); }
  /* 本命との違い（データで言えることだけ）。2台目以降の「何が違うのか」を1行で（round-1 P8） */
  function diffHTML(p, hon) {
    if (!hon || p === hon) return '';
    var d = [];
    var dp = p.pi - hon.pi;
    if (!p.na && !hon.na && Math.abs(dp) >= 1000) d.push(dp > 0 ? yen(dp) + '高い' : yen(-dp) + '安い');
    if (p.fam !== hon.fam) d.push(FAMILY_NAME[p.fam]);
    if (p.gear && hon.gear && p.gear !== hon.gear) d.push(GEAR_NAME[p.gear]);
    if (p.ts && hon.ts && p.ts !== hon.ts && p.ts !== '650') d.push('タイヤ' + p.ts);
    var wp = weightText(p), wh = weightText(hon);
    if (wp && wh && wp !== wh) d.push('重さ' + wp);
    if (!!p.li !== !!hon.li) d.push(p.li ? 'オートライトあり' : 'オートライトの記載なし');
    if (p.cs && hon.cs && p.cs !== hon.cs && p.cs !== 'none') d.push({ front: '前の席付き', rear: 'うしろの席付き', both: '前とうしろ両方に対応' }[p.cs] || '');
    // フレームは素材の名前だけ比べる（メーカーの英語の仕様文をそのまま出さない・round-6 P4）
    var mat = function (f) { f = String(f || ''); return /カーボン|carbon/i.test(f) ? 'カーボン' : STEEL_RE.test(f) ? 'クロモリ（鉄）' : /アルミ|alu|al\b/i.test(f) ? 'アルミ' : ''; };
    if (mat(p.frm) && mat(hon.frm) && mat(p.frm) !== mat(hon.frm)) d.push('フレーム' + mat(p.frm));
    var extra = (p.sty || []).filter(function (t) { return (hon.sty || []).indexOf(t) < 0 && !/ハンドル/.test(t); }).slice(0, 2);
    if (extra.length) d.push(extra.join('・'));
    if (p.v !== hon.v) d.push(p.v);
    d = d.filter(Boolean);
    // データで違いが言えないときは、そう書く（round-5 P9「W273とS273の違いがどこにも無い」）
    if (!d.length || (d.length === 1 && Math.abs(dp) >= 1000 && p.v === hon.v)) d.push('データの上では、ほかに大きな違いが見当たりません。店舗で並べて見比べてください');
    return '<p class="cs-diag__diff"><span>本命との違い</span>' + esc(d.join('／')) + '</p>';
  }
  function specHTML(p) {
    var rows = [];
    rows.push(['種類', kindText(p)]);
    if (p.gr) rows.push(['変速', p.gr === '外装' ? '外装変速' : p.gr === '内装' ? '内装変速' : '変速なし']);
    if (p.wkg) rows.push(['重さ', p.wkg + 'kg（メーカー公表）']);
    else if (p.wt) rows.push(['重さ', p.wt]);
    if (p.hmin != null) rows.push(['適応身長', heightText(p)]);
    // タイヤ「650」だけの値は大きさが一つに決まらないので出さない（round-1 P6・P7）
    if (p.ts && p.ts !== '650') rows.push(['タイヤ', p.ts]);
    if (p.li) rows.push(['ライト', p.li]);
    // 自社ECのスペック表（色・重さ・変速の段数・バッテリー）。表の文字をそのまま出す
    // 同じ項目（変速など）はECの表のほうが詳しい（段数まで書いてある）ので置き換える。重さは公表値があればそちら
    var idx = {}; rows.forEach(function (r, i) { idx[r[0]] = i; });
    (p.ec || []).forEach(function (r) {
      if (!r || !r[0] || !r[1]) return;
      var k = /重量|重さ/.test(r[0]) ? '重さ' : r[0];
      if (k === '重さ' && p.wkg) return;
      if (idx[k] != null) rows[idx[k]] = [k, r[1]]; else { idx[k] = rows.length; rows.push([k, r[1]]); }
    });
    return '<dl class="cs-diag__spec">' + rows.map(function (r) { return '<div><dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1]) + '</dd></div>'; }).join('') + '</dl>';
  }
  function storesSorted(p, stores, geo) {
    var list = (p.si || []).map(function (i) { return stores[i]; }).filter(Boolean);
    if (geo) list = list.map(function (st) { return { st: st, d: isFinite(st[3]) ? km(geo.lat, geo.lng, st[3], st[4]) : 1e9, n: isNear(st, geo) }; })
      .sort(function (x, y) { return (y.n - x.n) || (x.d - y.d); }).map(function (x) { return { st: x.st, d: x.d, n: x.n }; });
    else list = list.map(function (st) { return { st: st, d: null }; });
    if (!list.length && p.sh) list = p.sh.map(function (x) { return { st: [x.h, x.n], d: null }; });
    return list;
  }
  function storesHTML(p, ctx) {
    var list = storesSorted(p, ctx.stores, ctx.geo);
    if (!list.length) return '';
    var real = ctx.realGeo;
    var link = function (x) { return '<a href="/pages/store/' + esc(x.st[0]) + '">' + esc(shortStore(x.st[1])) + (real && x.d < 1e8 ? '（' + fmtKm(x.d) + '）' : '') + '</a>'; };
    if (ctx.geo && !real) {
      // 答えた地域の店舗と、それ以外を分けて書く（round-3「埼玉の店舗から、に東京の店舗が並ぶ」）
      var inA = list.filter(function (x) { return x.n; }), outA = list.length - inA.length;
      if (inA.length) return '<p class="cs-diag__stores"><span>' + esc(ctx.geo.n) + (/^t/.test(ctx.geo.code || '') ? 'のあたり（中心からおよそ10km）' : '') + 'で在庫のある店舗</span> ' + inA.slice(0, 3).map(link).join('・')
        + (inA.length > 3 ? ' ほか' + (inA.length - 3) + '店舗' : '') + (outA ? '。ほかの地域にも' + outA + '店舗' : '') + '</p>';
      // 1店舗だけのときは「近いのは」と言わない（round-4 P6: 立川の人に土浦店が「近い」）
      if (list.length === 1) return '<p class="cs-diag__stores"><span>' + esc(ctx.geo.n) + 'のあたりには在庫がありません</span> 在庫があるのは' + link(list[0]) + 'だけです'
        + '。近くの店舗へ取り寄せられるか、お電話でご相談ください</p>';
      return '<p class="cs-diag__stores"><span>' + esc(ctx.geo.n) + 'のあたりには在庫がありません</span> 近いのは' + link(list[0]) + '（ほか' + (list.length - 1) + '店舗）'
        + '。近くの店舗へ取り寄せられるか、お電話でご相談ください</p>';
    }
    var show = list.slice(0, 3);
    return '<p class="cs-diag__stores"><span>在庫のある店舗' + (real ? '（近い順）' : '') + '</span> ' + show.map(link).join('・')
      + ((p.st || 0) > show.length ? ' ほか' + (p.st - show.length) + '店舗' : '') + '</p>';
  }
  function imgHTML(p, big) {
    if (!p.img) return '<div class="cs-diag__img cs-diag__img--none">写真を準備しています</div>';
    var src = big ? String(p.img).replace('width=400', 'width=900') : p.img;
    return '<img class="cs-diag__img" src="' + esc(src) + '" alt="' + esc(p.v + ' ' + displayName(p)) + '" loading="lazy" width="' + (big ? 900 : 400) + '" height="' + (big ? 900 : 400) + '">';
  }
  /* 紹介文。かぎかっこが閉じないまま切れているものは、閉じる前の文で止める（round-1 P6・P7） */
  function descOf(p, text) {
    var t = String((text[p.h] || {}).ds || '');
    var open = (t.match(/「/g) || []).length, close = (t.match(/」/g) || []).length;
    if (open > close) {
      var cut = t.lastIndexOf('「');
      var prev = t.lastIndexOf('。', cut);
      t = prev > 0 ? t.slice(0, prev + 1) : '';
    }
    return t;
  }
  /* ブランド紹介は、すすめた一台と食い違う文を外して2文まで（round-2: アルミ車にクロモリの話、
     16インチに14インチの数字、電動ではない人に電動の話）。文は書き換えない */
  function brandLine(b, p) {
    if (!b || !b.desc) return '';
    var s = String(b.desc).split('。').map(function (x) { return x.trim(); }).filter(Boolean).filter(function (x, i) {
      if (/極め|高く評価|革新|最高|唯一/.test(x)) return false;
      if (i === 0) return true;
      if (/\d+(インチ|kg|km)/.test(x)) return false;
      if (p && !p.el && /電動|アシスト|モーター|Eバイク|e-?bike/i.test(x)) return false;
      if (p && p.fam === 'kids' && /ベルトドライブ|ロード|レース/.test(x)) return false;
      if (p && !STEEL_RE.test(p.frm || '') && /クロモリ|スチール|鉄/.test(x)) return false;
      if (/極め|高く評価|革新|最高|唯一/.test(x)) return false;
      return true;
    });
    return s.slice(0, 2).join('。') + '。';
  }

  /* キャッチコピーはメーカー由来の文。サイトが名乗る約束の禁止語（§2）が入っているものは出さない */
  var NG_COPY = /安心|笑顔|親切|丁寧|すぐ|必ず|いちばん|一番|No\.?1|最高|最強|最軽量|人気|豊富|充実|パンクしない|止まらない/;

  function pickHTML(r, i, ctx) {
    var p = r.p, big = r.role === 'honmei';
    var b = ctx.brands[p.v] || {};
    var ds = descOf(p, ctx.text);
    var nReasons = big ? 5 : 3;
    var h = '<article class="cs-diag__pick cs-diag__pick--' + r.role + '" id="cs-diag-pick-' + i + '">';
    h += '<p class="cs-diag__role">' + esc(roleLabel(r, ctx.story)) + '</p>';
    if (r.role === 'up' && r.note && !p.na && !(ctx.hon && ctx.hon.na)) h += '<p class="cs-diag__rolenote">本命より' + esc(yen(Math.max(0, p.pi - ctx.honPrice))) + '上がると、' + esc(r.note) + 'なります。</p>';
    if (r.role === 'over' && r.budget && r.budget.over && !p.na) h += '<p class="cs-diag__rolenote">ご予算の上限より' + esc(yen(r.budget.over)) + '高い一台です。予算を少し広げられる場合の参考にご覧ください。</p>';
    if (r.role === 'save' && !p.na && !(ctx.hon && ctx.hon.na)) h += '<p class="cs-diag__rolenote">本命より' + esc(yen(Math.max(0, ctx.honPrice - p.pi))) + 'おさえられます。</p>';
    if (r.role === 'inbud') h += '<p class="cs-diag__rolenote">本命はご予算内の、下のほうの価格です。ご予算の価格帯から、同じ系統の一台も並べます。違いは下の比べる表でご覧ください。</p>';
    if (r.role === 'alt' && r.note) h += '<p class="cs-diag__rolenote">' + esc(r.note) + (/[。]$/.test(r.note) ? '' : '。') + '</p>';
    if (r.role === 'disco') h += '<p class="cs-diag__rolenote">取り扱う店舗は限られますが、' + esc(p.v) + 'という名前を覚えておくと、自転車選びが広がります。</p>';
    h += '<div class="cs-diag__pickgrid">';
    h += '<figure class="cs-diag__fig">' + imgHTML(p, big) + '</figure>';
    h += '<div class="cs-diag__pickbody">';
    h += '<p class="cs-diag__vendor">' + esc(p.v) + '</p>';
    h += '<h3 class="cs-diag__name">' + esc(displayName(p)) + '</h3>';
    h += p.na ? '<p class="cs-diag__price cs-price-ask">' + ASK + '</p>' : '<p class="cs-diag__price">' + yen(p.pi) + '<span>（税込）</span></p>';
    if (p.cc && !NG_COPY.test(p.cc)) h += '<p class="cs-diag__cc">' + esc(p.cc) + '</p>';
    if (!big) h += diffHTML(p, ctx.hon);
    // 本命は共通の理由も含めて全部書く（round-4 P6「本命の理由が予算・在庫・身長だけ」）。2台目からは共通を外す
    h += reasonsHTML(r, nReasons, big ? [] : ctx.common, ctx.shownY, (ctx.common || []).length > 0);
    if (ds) h += '<div class="cs-diag__about"><p class="cs-diag__about-title">この自転車について</p><p>' + esc(ds) + '</p><p class="cs-diag__src">商品ページの紹介より</p></div>';
    if (b.desc && !ctx.brandShown[p.v]) {
      ctx.brandShown[p.v] = 1;
      h += '<div class="cs-diag__about"><p class="cs-diag__about-title">' + esc(p.v) + 'というブランド</p><p>' + esc(brandLine(b, p)) + '</p></div>';
    }
    var sp = specHTML(p);
    if (sp) h += '<details class="cs-diag__fold"' + (big ? ' open' : '') + '><summary>仕様を見る</summary>' + sp + '</details>';
    // 同じ注意は2回目から外す。ただし夜・雨の装備は台ごとに違うので毎回書く（round-5 P2「本命にしかライトの話が無い」）
    var cares = r.care.filter(function (c) { if (ctx.shownCare[c] && !/ライト|泥よけ/.test(c)) return false; ctx.shownCare[c] = 1; return true; }).slice(0, 2);
    if (cares.length) h += '<div class="cs-diag__care"><p class="cs-diag__care-title">気をつける点</p><ul>' + cares.map(function (c) { return '<li>' + esc(c) + '</li>'; }).join('') + '</ul></div>';
    h += (p.st || 0) < 1 ? '<p class="cs-diag__stock">' + (ctx.asof ? esc(ctx.asof) + '時点で、' : 'いま、') + '店舗に在庫はありません。入荷や取り寄せができるかは、お近くの店舗にお電話でご相談ください</p>'
      : '<p class="cs-diag__stock">' + (p.st || 0) + '店舗に在庫があります' + (ctx.asof ? '（' + esc(ctx.asof) + '時点）' : '')
      + ((p.st || 0) <= 1 ? '。1店舗だけなので、行く前にお電話で確かめてください' : '') + '</p>';
    h += storesHTML(p, ctx);
    h += '<div class="cs-diag__cta">'
      + '<a class="cs-btn' + (big ? ' cs-btn--primary' : '') + '" href="/products/' + esc(p.h) + '" data-cs-diag-go="product">この自転車を詳しく見る</a>'
      + '<button type="button" class="cs-btn" data-cs-diag-save="' + esc(p.h) + '" data-t="' + esc(displayName(p)) + '" data-i="' + esc(p.img || '') + '" data-p="' + esc(p.na ? '' : yen(p.pi)) + '" data-s="' + esc(p.v) + '">保存する</button>'
      + '</div>';
    h += '</div></div></article>';
    return h;
  }

  /* お答えと、それぞれの合うところ（2026-10-09 本間さん「こういう要素で選んでいるという」）
     行=答え、列=提案。○ 答えに合う／△ ある程度合う／－ 合うと言える情報が無い。
     本命が応えていない答えも隠さずに並べる（どの一台がその答えに応えているかが分かる） */
  function matchHTML(picks, ctx) {
    if (picks.length < 2) return '';
    var seen = {}, rows = [];
    (ctx.N || []).forEach(function (n) {
      if (!n.w || seen[n.id] || /^(near|height|size|kage)$/.test(n.id)) return;
      seen[n.id] = 1; rows.push(n);
    });
    if (rows.length > 9) rows = rows.slice().sort(function (x, y) { return y.w - x.w; }).slice(0, 9);
    var mark = function (r, n) {
      var w = r.why.filter(function (x) { return (x.ids || [x.id]).indexOf(n.id) >= 0; })[0];
      if (!w) return '<td class="is-no">－</td>';
      return (w.wmax || w.w) < n.w ? '<td class="is-half">△</td>' : '<td class="is-yes">○</td>';
    };
    var body = rows.map(function (n) {
      return '<tr><th scope="row">' + esc(String(n.ask).replace(/[「」]/g, '')) + '</th>' + picks.map(function (r) { return mark(r, n); }).join('') + '</tr>';
    }).join('');
    if (ctx.a.budget && BUDGET[ctx.a.budget]) body += '<tr><th scope="row">ご予算は' + esc(label('budget', ctx.a.budget, ctx.a)) + '</th>' + picks.map(function (r) {
      return r.budget.ok ? '<td class="is-yes">○</td>' : (r.budget.stretch || r.budget.stretch2) ? '<td class="is-half">△</td>' : '<td class="is-no">－</td>';
    }).join('') + '</tr>';
    return '<section class="cs-diag__match" aria-label="お答えと、それぞれの合うところ"><h2 class="cs-diag__h2">お答えと、それぞれの合うところ</h2>'
      + '<p class="cs-diag__match-key">○ 答えに合う　△ ある程度合う　－ 合うと言える情報が手元に無い</p>'
      + '<div class="cs-diag__tablewrap"><table><thead><tr><th scope="col">お答え</th>' + picks.map(function (r, i) {
        return '<th scope="col"><a href="#cs-diag-pick-' + i + '">' + esc(displayName(r.p)) + '</a><span>' + esc(roleLabel(r, ctx.story)) + '</span></th>';
      }).join('') + '</tr></thead><tbody>' + body + '</tbody></table></div></section>';
  }

  function compareHTML(picks, story) {
    if (picks.length < 2) return '';
    var rows = picks.map(function (r) {
      return '<tr><th scope="row"><a href="#cs-diag-pick-' + picks.indexOf(r) + '">' + esc(displayName(r.p)) + '</a><span>' + esc(roleLabel(r, story)) + '</span></th>'
        + '<td>' + esc(priceText(r.p)) + '</td><td>' + esc(FAMILY_NAME[r.p.fam] || '') + (r.p.gear ? '・' + esc(GEAR_NAME[r.p.gear]) : '') + '</td><td>' + esc(weightText(r.p) || '—') + '</td><td>' + ((r.p.st || 0) ? r.p.st + '店舗' : 'なし') + '</td></tr>';
    }).join('');
    return '<section class="cs-diag__compare" aria-label="提案の比べ表"><h2 class="cs-diag__h2">並べて比べる</h2>'
      + '<div class="cs-diag__tablewrap"><table><thead><tr><th scope="col">自転車</th><th scope="col">税込</th><th scope="col">種類・変速</th><th scope="col">重さ</th><th scope="col">在庫</th></tr></thead><tbody>' + rows + '</tbody></table></div></section>';
  }

  /* 1か所で何台見比べられるか。本命が置いてある店舗だけ（round-1 P10「本命が無い店舗を案内された」） */
  function overlapStores(picks, stores, geo) {
    var cnt = {};
    var hon = {}; (picks[0].p.si || []).forEach(function (i) { hon[i] = 1; });
    picks.forEach(function (r) { (r.p.si || []).forEach(function (i) { cnt[i] = (cnt[i] || 0) + 1; }); });
    var arr = Object.keys(cnt).map(function (i) { return { i: +i, n: cnt[i] }; }).filter(function (x) { return x.n >= 2 && hon[x.i] && stores[x.i]; });
    arr.forEach(function (x) { var st = stores[x.i]; x.d = geo && isFinite(st[3]) ? km(geo.lat, geo.lng, st[3], st[4]) : null; x.near = isNear(st, geo); });
    // 地域が分かれば、その地域の店舗だけ（遠い店舗で3台より、行ける店舗で2台）
    if (geo) arr = arr.filter(function (x) { return x.near; });
    arr.sort(function (x, y) { return (y.n - x.n) || ((x.d == null ? 1e9 : x.d) - (y.d == null ? 1e9 : y.d)); });
    return arr.slice(0, 3).map(function (x) { var st = stores[x.i]; return { h: st[0], n: st[1], c: x.n, d: x.d }; });
  }

  function nextStepHTML(ctx) {
    var a = ctx.a, picks = ctx.picks;
    var h = '<section class="cs-diag__visit"><h2 class="cs-diag__h2">店舗で確かめること</h2>'
      + '<p class="cs-diag__p">写真と数字で分かるのはここまでです。店舗で、次のことを確かめてください。スタッフにこの画面を見せていただければ、お答えの内容から相談を始められます。</p>'
      + '<ol class="cs-diag__check">' + checklist(a, picks).map(function (c) { return '<li>' + esc(c) + '</li>'; }).join('') + '</ol>';
    var ov = overlapStores(picks, ctx.stores, ctx.geo);
    var honStores = storesSorted(picks[0].p, ctx.stores, ctx.geo);
    if (ov.length) {
      h += '<h3 class="cs-diag__h3">本命と並べて見比べられる店舗</h3><ul class="cs-diag__overlap">'
        + ov.map(function (x) { return '<li><a href="/pages/store/' + esc(x.h) + '">' + esc(shortStore(x.n)) + '</a>' + (ctx.realGeo && x.d != null ? '（' + fmtKm(x.d) + '）' : '') + '　この提案のうち' + x.c + '台の在庫があります</li>'; }).join('')
        + '</ul>';
    } else if (honStores.length) {
      h += '<h3 class="cs-diag__h3">本命を見に行ける店舗</h3><p class="cs-diag__p">' + honStores.slice(0, 3).map(function (x) { return esc(shortStore(x.st[1])); }).join('・')
        // 提案が1台のときに「ほかの候補」と書かない（2026-10-14 確認用画面）
        + '。' + (picks.length > 1 ? 'ほかの候補は別の店舗にあります。見比べたいときは、取り寄せて並べられるかを店舗にご相談ください。' : '') + '</p>';
    }
    var t = a.timing;
    var go = ov.length ? ov[0] : honStores.length ? { h: honStores[0].st[0], n: honStores[0].st[1] } : null;
    h += '<h3 class="cs-diag__h3">次の一歩</h3><p class="cs-diag__p">'
      // 提案のどれも店舗に在庫が無いとき（扱いのある自転車から選ぶようにした・2026-10-09）は、見に行く話をしない
      + (!go && t !== 'later' ? 'いまは提案した自転車の店舗在庫がありません。お近くの店舗にお電話で、入荷や取り寄せができるかを聞いてみてください。電話番号は店舗のページにあります。'
        : t === 'soon' ? '早めに乗り始めたいとのことなので、行く前に' + (go ? esc(shortStore(go.n)) + 'へ' : '在庫のある店舗へ') + 'お電話ください。在庫が残っているか、取り置きができるかをその場でお答えします。電話番号は店舗のページにあります。'
        : t === 'month' ? 'ひと月のうちに決めるなら、週末に' + (go ? esc(shortStore(go.n)) + 'で' : '1か所で') + (ov.length ? '見比べるのが近道です。' : '本命を見て、ほかの候補を取り寄せられるか聞いてみてください。') + '保存した自転車は、このサイトの「保存したもの」からいつでも見返せます。'
          : '急がないなら、この結果を保存しておいてください。このページのアドレスに答えが入っているので、あとで開いても同じ結果が出ます。在庫は週に一度入れ替わります。')
      + '</p>';
    // 買ったあと（会社の考え: いい自転車を買って、きちんとメンテして長く乗ってほしい）
    h += '<h3 class="cs-diag__h3">買ったあとのこと</h3><p class="cs-diag__p">点検や修理は、買った店舗でなくても受け付けています。工賃は全店舗同じで、<a href="/pages/repair-fees">工賃表</a>で先に確かめられます。いい一台を選んで、手入れしながら長く乗っていただけたらうれしいです。</p>';
    h += '<div class="cs-diag__more">'
      + (go ? '<a class="cs-btn" href="/pages/store/' + esc(go.h) + '" data-cs-diag-go="store">' + esc(shortStore(go.n)) + 'のページを見る</a>' : '<a class="cs-btn" href="/pages/stores" data-cs-diag-go="store">店舗をさがす</a>')
      + (ctx.share ? '<button type="button" class="cs-btn" data-cs-diag-share>この結果のアドレスをコピー</button>' : '')
      + '<button type="button" class="cs-btn" data-cs-diag-edit>答えを直す</button>'
      + '<button type="button" class="cs-btn" data-cs-diag-restart>はじめからやり直す</button>'
      + '</div></section>';
    return h;
  }

  var STORY_HEAD = {
    kids: 'お子さんの一台を選びました',
    family: '送り迎えの一台を選びました',
    hobby: '走る楽しみのための一台を選びました',
    choice: '長く付き合える一台を選びました',
    unique: '人と被らない、好みの一台を選びました',
    school: '毎日の通学に乗る一台を選びました',
    daily: '毎日の足になる一台を選びました',
  };

  function render(ctx) {
    var a = ctx.a, picks = ctx.picks;
    if (!picks.length) {
      return '<header class="cs-diag__result-head"><p class="cs-diag__kicker">診断の結果</p>'
        + '<h2 class="cs-diag__headline">お答えに合う自転車が、いま見つかりませんでした</h2>'
        + '<p class="cs-diag__p">条件を少し変えると候補が出ることがあります。取り寄せできる車種もあるので、店舗でご相談ください。</p></header>'
        + '<div class="cs-diag__more"><button type="button" class="cs-btn" data-cs-diag-edit>答えを直す</button><a class="cs-btn" href="/pages/stores">店舗をさがす</a></div>';
    }
    ctx.honPrice = picks[0].p.pi;
    ctx.hon = picks[0].p;
    ctx.brandShown = {};
    ctx.shownY = {};
    ctx.shownCare = {};
    ctx.common = commonReasons(picks);
    var h = '<header class="cs-diag__result-head">'
      + '<p class="cs-diag__kicker">診断の結果</p>'
      + '<h2 class="cs-diag__headline">' + esc(STORY_HEAD[ctx.story]) + '</h2>'
      + '<div class="cs-diag__recap"><p class="cs-diag__recap-title">お話をまとめると</p><p class="cs-diag__recap-text">' + esc(recap(a)) + '</p>'
      + (factors(a).length ? '<ul class="cs-diag__chips">' + factors(a).map(function (f) { return '<li>' + esc(f.t) + '</li>'; }).join('') + '</ul>' : '')
      + (ctx.gap ? '<p class="cs-diag__gap">' + esc(ctx.gap) + '</p>' : '<p class="cs-diag__recap-count">' + (ctx.counts.fit ? '条件に合う' + ctx.counts.fit + '台から、' + picks.length + '台を選びました。'
        // そのまま合うものが無いとき、絞る前の台数を「条件に合う」と言わない（2026-10-09 納得チェック: 「合う161台から1台」）
        : 'ご予算とお答えにそのまま合う自転車が無かったため、近いものから' + picks.length + '台を選びました。') + '</p>') + '</div>'
      // 選ぶ基準は読みたい人だけ開く（結果を先に見せる・2026-10-09 本間さん「結果の見せ方も正直イマイチ」）
      + '<details class="cs-diag__fold"><summary>選ぶときに見たこと</summary><ul class="cs-diag__how-list">'
      + criteria(a, ctx.N, ctx.counts, picks).map(function (c) { return '<li>' + esc(c) + '</li>'; }).join('') + '</ul>'
      + '</details>';
    // 共通の理由は本命のカードに書き、2台目からは「本命と同じ」と1行で添える（round-6 P7・P8「同じ理由が2回出る」）
    h += '</header>';
    if (!ctx.realGeo) h += '<div class="cs-diag__geo"><button type="button" class="cs-btn" data-cs-diag-geo>いまいる場所から近い在庫店舗を出す</button><span class="cs-diag__geo-status" data-cs-diag-geostatus aria-live="polite"></span></div>';
    // ひと目で並べる。写真・役割・価格と、答えに結びついた事実を2つ。押すと下の紹介へ
    // 1台だけのときは一覧を出さない（すぐ下の紹介と同じカードが2回続いて見えた・2026-10-14 ペルソナ点検）
    if (picks.length > 1) h += '<nav class="cs-diag__lineup" aria-label="提案の一覧"><ol>' + picks.map(function (r, i) {
      var facts = r.why.filter(function (w) { return !w.quiet && w.id !== 'budget' && w.id !== 'near' && w.id !== 'height'; }).slice(0, 2);
      return '<li class="cs-diag__lineup-item' + (i === 0 ? ' is-honmei' : '') + '"><a href="#cs-diag-pick-' + i + '">'
        + '<span class="cs-diag__lineup-role">' + esc(roleLabel(r, ctx.story)) + '</span>'
        + (r.p.img ? '<img src="' + esc(r.p.img) + '" alt="" width="400" height="400" loading="lazy">' : '<span class="cs-diag__lineup-noimg">写真を準備しています</span>')
        + '<span class="cs-diag__lineup-vendor">' + esc(r.p.v) + '</span><span class="cs-diag__lineup-name">' + esc(displayName(r.p)) + '</span>'
        + '<span class="cs-diag__lineup-price">' + esc(priceText(r.p)) + '</span>'
        + (facts.length ? '<span class="cs-diag__lineup-why">' + facts.map(function (w) { return esc(w.f); }).join('<br>') + '</span>' : '')
        + '<span class="cs-diag__lineup-stock">' + ((r.p.st || 0) ? r.p.st + '店舗に在庫' : '店舗在庫なし') + '</span>'
        + '</a></li>';
    }).join('') + '</ol></nav>';
    h += matchHTML(picks, ctx);
    h += '<div class="cs-diag__picks">' + picks.map(function (r, i) { return pickHTML(r, i, ctx); }).join('') + '</div>';
    h += compareHTML(picks, ctx.story);
    h += nextStepHTML(ctx);
    return h;
  }

  /* ───────────── 答えをURLに入れる（店舗で見せる・あとで開く） ───────────── */
  var KEYS = ['rider', 'image', 'mood', 'kids_count', 'kids_age', 'child_height', 'child_use', 'use', 'dist', 'cond', 'place', 'height', 'area', 'electric', 'budget', 'priority', 'look', 'child_look', 'style', 'timing'];
  function encode(a) {
    var val = function (k) { return k === 'use' && a.uses ? a.uses : k === 'priority' && a.priorities ? a.priorities : a[k]; };
    return KEYS.filter(function (k) { var v = val(k); return v != null && v !== '' && !(Array.isArray(v) && !v.length); })
      .map(function (k) { var v = val(k); return k + '.' + (Array.isArray(v) ? v.join('+') : v); }).join('~');
  }
  function decode(s) {
    var a = {};
    String(s || '').split('~').forEach(function (kv) {
      var i = kv.indexOf('.'); if (i < 0) return;
      var k = kv.slice(0, i), v = kv.slice(i + 1);
      if (KEYS.indexOf(k) < 0) return;
      a[k] = k === 'cond' || k === 'use' || k === 'priority' ? v.split('+').filter(Boolean) : v;
    });
    return a.rider ? a : null;
  }

  /* ───────────── 答えている途中の候補（2026-10-09 本間さん「ボタンを押すたびに候補が切り替わるような動き」）
     結果と同じ採点を、答えた分だけで回す。「合う」= 予算の中・答えに反するところが無い・思い描いた形 */
  function prepOnce(data) {
    if (!data._prep) data._prep = prep(data.products || []);
    return data._prep;
  }
  function fitList(answers, data, text) {
    var a = normalize(answers), brands = data.brands || {};
    var all = prepOnce(data), tx = text || {};
    all.forEach(function (p) { var t = tx[p.h]; if (t && t.wkg) p.wkg = t.wkg; });
    var N = needs(a, brands);
    var geo = AREA[a.area] ? { lat: AREA[a.area].lat, lng: AREA[a.area].lng, n: AREA[a.area].n, code: a.area, approx: true } : null;
    var scored = hardFilter(all, a).map(function (p) { var r = score(p, a, N, brands, { stores: data.stores || [], geo: geo }); r.p = p; return r; })
      .sort(function (x, y) { return y.s - x.s || (y.p.st || 0) - (x.p.st || 0); });
    scored = dedupe(scored);
    var img = a.image && a.image !== 'undecided' ? a.image : '';
    var fit = scored.filter(function (r) { return r.budget.ok && !r.bad && (!img || imageMatch(img, r.p.fam) || (img === 'town' && /cross|mini|city/.test(r.p.fam))); });
    return { a: a, fit: fit, total: scored.length, scored: scored, brands: brands };
  }
  /* いま効いている条件（答えた質問を短い言葉で） */
  var CHIP_SKIP = { rider: 1, timing: 1 };
  function factors(a) {
    var out = [];
    flowFor(a).forEach(function (q) {
      if (CHIP_SKIP[q.id]) return;
      var v = q.id === 'use' ? a.uses : q.id === 'priority' ? a.priorities : a[q.id];
      if (v == null || v === '' || (Array.isArray(v) && !v.length)) return;
      (Array.isArray(v) ? v : [v]).forEach(function (x) {
        var l = label(q.id, x, a);
        var o = null; q.options.forEach(function (y) { if (y.v === x) o = y; });
        if (l) out.push({ q: q.id, t: (o && o.chip) || l.replace(/（.*?）/g, '') });
      });
    });
    return out;
  }
  // 途中の候補に添える「どこが合っているか」。事実の言葉を重ねずに3つまで（「クロスバイク・クロスバイク」を防ぐ）
  function whyShort(r) {
    var seen = {}, out = [];
    r.why.filter(function (w) { return !w.quiet && w.id !== 'budget' && w.id !== 'near' && w.id !== 'height'; }).forEach(function (w) {
      String(w.f).split('・').forEach(function (t) {
        t = t.trim();
        // 「ステップスルー」と「フレームの低い形（ステップスルー）」のように、片方がもう片方を含むなら1つに
        if (!t || seen[t] || out.length >= 3 || out.some(function (o) { return o.indexOf(t) >= 0 || t.indexOf(o) >= 0; })) return;
        seen[t] = 1; out.push(t);
      });
    });
    return out.join('・');
  }
  function peek(answers, data, text) {
    var f = fitList(answers, data, text);
    // 「特によく合う」= いちばん合う一台の8割以上の点。答えるほど差がついて数が変わる
    var best = f.fit.length ? f.fit[0].s : 0;
    return {
      n: f.fit.length,
      good: best > 0 ? f.fit.filter(function (r) { return r.s >= best * 0.8; }).length : f.fit.length,
      // 上位3台は、いまの答えで最後まで進んだときの提案と同じ選び方で出す（round-8 P4・P7・P8
      // 「途中で出ていた一台が、結果では消えた」）
      top: (function () { var pk = []; try { pk = pick(f.scored, f.a, f.brands); } catch (e) { pk = []; } return pk.length ? pk : f.fit; })().slice(0, 3).map(function (r) {
        return { h: r.p.h, v: r.p.v, name: displayName(r.p), pi: r.p.pi, na: r.p.na, img: r.p.img || '', st: r.p.st || 0,
          why: whyShort(r) };
      }),
      factors: factors(f.a),
    };
  }
  /* 選択肢ごとの「選んだら何台残るか」。答えに反するものしか残らない選択肢を先に知らせる */
  function optionCounts(q, answers, data, text) {
    var out = {};
    q.options.forEach(function (o) {
      var b = {}; for (var k in answers) if (Object.prototype.hasOwnProperty.call(answers, k)) b[k] = answers[k];
      b[q.id] = q.multi ? (o.v ? [o.v] : []) : o.v;
      out[o.v] = fitList(b, data, text).fit.length;
    });
    return out;
  }

  var engine = { QUESTIONS: QUESTIONS, CH: CH, flowFor: flowFor, diagnose: diagnose, encode: encode, decode: decode, normalize: normalize, peek: peek, optionCounts: optionCounts };

  /* ───────────── ブラウザ ───────────── */
  if (typeof module === 'object' && module.exports) { module.exports = engine; return; }
  G.CSDiagnosis = engine;

  function track(name, params) {
    try { G.dataLayer = G.dataLayer || []; G.dataLayer.push(Object.assign({ event: name }, params || {})); } catch (e) { /* 計測は本体を止めない */ }
    /* dataLayer はピクセル（別枠）から読めず GA4 に届かない。同じ内容を csTrack（snippets/cs-analytics.liquid）でも送る（2026-10-11） */
    try { if (typeof G.csTrack === 'function') G.csTrack(name, params || {}); } catch (e) { /* 計測は本体を止めない */ }
  }
  var GEO_KEY = 'cs_geo';
  function readGeo() {
    try { var g = JSON.parse(localStorage.getItem(GEO_KEY) || 'null'); return g && isFinite(g.lat) && isFinite(g.lng) ? g : null; } catch (e) { return null; }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-cs-diagnosis]');
    if (!root) return;
    var data = null, text = {}, answers = {}, step = 0, editing = false, multiSel = [];

    function flow() { return flowFor(answers); }
    function asofText() {
      var t = document.querySelector('[data-cs-diag-asofdate]');
      return t ? t.textContent.trim() : '';
    }

    // 答えている途中の候補。前の質問のときの上位を覚えておき、新しく入った一台に印を付ける
    var lastTop = {}, lastN = null;
    function peekHTML(ans, keep) {
      var pk;
      ans = ans || answers;
      try { pk = peek(ans, data, text); } catch (e) { return ''; }
      // 誰が乗るかしか答えていないうちは、数だけ（全部の中の上位3台を出しても意味がない）
      if (Object.keys(ans).filter(function (k) { return k !== 'rider'; }).length === 0) return '<aside class="cs-diag__peek" aria-live="polite" aria-label="いまの候補"><p class="cs-diag__peek-title">いまの候補</p>'
        + '<p class="cs-diag__peek-count"><strong>' + pk.n + '</strong>台の中から選びます</p><p class="cs-diag__peek-note">答えるたびに、合う自転車がここで入れ替わります。</p></aside>';
      var h = '<aside class="cs-diag__peek" aria-live="polite" aria-label="いまの候補">'
        + '<p class="cs-diag__peek-title">いまの候補</p>'
        + '<p class="cs-diag__peek-count"><strong>' + pk.n + '</strong>台が条件に合います</p>'
        + (pk.good !== pk.n ? '<p class="cs-diag__peek-sub">そのうち特によく合うのは ' + pk.good + '台</p>' : '')
        + (lastN != null && lastN !== pk.n ? '<p class="cs-diag__peek-sub cs-diag__peek-delta">前の質問から' + (pk.n < lastN ? ' ' + (lastN - pk.n) + '台しぼりました' : ' ' + (pk.n - lastN) + '台ふえました') + '</p>' : '');
      if (!pk.n) h += '<p class="cs-diag__peek-note">いまの答えの組み合わせに、そのまま合う自転車はありません。最後まで答えると、近いものを理由つきで出します。</p>';
      if (pk.top.length) h += '<ol class="cs-diag__peek-list">' + pk.top.map(function (t, i) {
        var fresh = lastN != null && !lastTop[t.h];
        return '<li class="cs-diag__peek-item' + (fresh ? ' is-new' : '') + '">'
          + (t.img ? '<img src="' + esc(t.img) + '" alt="" width="64" height="64" loading="lazy">' : '<span class="cs-diag__peek-noimg"></span>')
          + '<span class="cs-diag__peek-body"><span class="cs-diag__peek-rank">' + (i + 1) + '</span>' + (fresh ? '<span class="cs-diag__peek-new">新しく入りました</span>' : '')
          + '<span class="cs-diag__peek-vendor">' + esc(t.v) + '</span><span class="cs-diag__peek-name">' + esc(t.name) + '</span>'
          + '<span class="cs-diag__peek-price">' + esc(priceText(t)) + '</span>'
          + (t.why ? '<span class="cs-diag__peek-why">' + esc(t.why) + '</span>' : '') + '</span></li>';
      }).join('') + '</ol>';
      if (pk.factors.length) h += '<div class="cs-diag__peek-factors"><p class="cs-diag__peek-title">いま見ていること</p><ul class="cs-diag__chips">' + pk.factors.map(function (f) { return '<li>' + esc(f.t) + '</li>'; }).join('') + '</ul></div>';
      else h += '<p class="cs-diag__peek-note">答えるたびに、合う自転車が入れ替わります。</p>';
      h += '</aside>';
      if (!keep) { lastTop = {}; pk.top.forEach(function (t) { lastTop[t.h] = 1; }); lastN = pk.n; }
      return h;
    }
    // 複数選べる質問は、押すたびにその場で候補を入れ替える（前の質問との比べは崩さない）
    function refreshPeek(ans) {
      var old = root.querySelector('.cs-diag__peek');
      if (!old) return;
      var saveTop = lastTop, saveN = lastN;
      lastTop = prevTop; lastN = prevN;
      var w = document.createElement('div'); w.innerHTML = peekHTML(ans, true);
      lastTop = saveTop; lastN = saveN;
      if (w.firstChild) old.parentNode.replaceChild(w.firstChild, old);
    }
    var prevTop = {}, prevN = null;

    function drawQuestion() {
      var qs = flow(), q = qs[step];
      // 質問の数は、だれが乗るかで7〜15問に変わる。答える前は数を出さない
      // （答える前の11が次の画面で15に増えて見えた・2026-10-14 ペルソナ点検「1/11 → 2/15」）
      var total = qs.length, known = !!answers.rider;
      var pct = Math.round(step / total * 100);
      // 選んだら何台残るか。数に差がある質問だけ添える（差が無いのに並べると読む手間だけ増える）
      var oc = {}, showN = false, hi = 0, gapMin = 3;
      try {
        oc = optionCounts(q, answers, data, text);
        var vals = q.options.filter(function (o) { return o.v; }).map(function (o) { return oc[o.v]; });
        hi = Math.max.apply(null, vals);
        // 選ぶと合う自転車がはっきり減る選択肢にだけ数を添える（1〜2台の差は誤差に見えるだけ）。0台は必ず出す
        gapMin = Math.max(3, Math.round(hi * 0.1));
        showN = vals.length > 1 && vals.some(function (x) { return x === 0 || hi - x >= gapMin; });
      } catch (e) { oc = {}; }
      var nTag = function (o) {
        if (!showN || !o.v || oc[o.v] == null || (oc[o.v] && hi - oc[o.v] < gapMin)) return '';
        return oc[o.v] ? '<span class="cs-diag__optn">' + oc[o.v] + '台</span>' : '<span class="cs-diag__optn cs-diag__optn--none">合う自転車なし</span>';
      };
      var h = '<div class="cs-diag__asklayout"><div class="cs-diag__askmain">'
        + '<div class="cs-diag__progress" role="progressbar" aria-valuemin="0" aria-valuemax="' + total + '" aria-valuenow="' + step + '"><div class="cs-diag__progress-bar" style="width:' + pct + '%"></div></div>'
        + '<p class="cs-diag__step"><span>' + esc(CH[q.ch]) + '</span>質問 ' + (step + 1) + (known ? ' / ' + total : '') + '</p>'
        + '<h2 class="cs-diag__q">' + esc(q.q) + '</h2>'
        + (q.note ? '<p class="cs-diag__qnote">' + esc(q.note) + '</p>' : '');
      if (q.multi) {
        multiSel = (answers[q.id] || []).slice();
        h += '<div class="cs-diag__opts">' + q.options.map(function (o) {
          var on = multiSel.indexOf(o.v) >= 0;
          return '<button type="button" class="cs-diag__opt cs-diag__opt--multi" aria-pressed="' + on + '" data-mv="' + esc(o.v) + '"><span>' + esc(o.label) + '</span>' + nTag(o) + '</button>';
        }).join('') + '</div>'
          + '<div class="cs-diag__nav"><button type="button" class="cs-btn cs-btn--primary" data-cs-diag-next>' + (multiSel.length || q.max ? '次へ' : '当てはまるものはない') + '</button></div>';
      } else {
        h += '<div class="cs-diag__opts">' + q.options.map(function (o) {
          var on = answers[q.id] === o.v && Object.prototype.hasOwnProperty.call(answers, q.id);
          return '<button type="button" class="cs-diag__opt" aria-pressed="' + on + '" data-v="' + esc(o.v) + '"><span>' + esc(o.label) + '</span>' + nTag(o) + '</button>';
        }).join('') + '</div>';
      }
      if (showN) h += '<p class="cs-diag__qnote">数が出ている答えは、選ぶと合う自転車が減るものです（数は、選んだあとに条件に合う台数）。</p>';
      h += '<div class="cs-diag__nav">' + (step > 0 ? '<button type="button" class="cs-diag__back" data-cs-diag-back>前の質問にもどる</button>' : '')
        + (editing ? '<button type="button" class="cs-diag__back" data-cs-diag-result>この答えで結果を見る</button>' : '') + '</div>';
      prevTop = lastTop; prevN = lastN;
      h += '</div>' + peekHTML() + '</div>';
      root.innerHTML = h;
    }

    function finish(fromHash) {
      var geo = readGeo();
      var code = encode(normalize(answers));
      var share = location.pathname + '#d=' + code;
      try { if (!fromHash && history.replaceState) history.replaceState(null, '', '#d=' + code); } catch (e) {}
      var res = diagnose(answers, data, text, { geo: geo, asof: asofText(), share: share });
      root.innerHTML = res.html;
      var asofT = document.querySelector('[data-cs-diag-asof]');
      if (asofT && asofT.content) { var m = document.createElement('div'); m.className = 'cs-diag__asofwrap'; m.appendChild(asofT.content.cloneNode(true)); root.appendChild(m); }
      paintSaved();
      track('cs_diagnosis_complete', { story: res.story, results: res.picks.length, pool: res.pool, has_geo: !!geo, rider: answers.rider || '', image: answers.image || '', budget: answers.budget || '', timing: answers.timing || '', top_handle: res.picks[0] ? res.picks[0].p.h : '', roles: res.picks.map(function (r) { return r.role; }).join(',') });
    }

    function answer(q, v) {
      answers[q.id] = v;
      track('cs_diagnosis_answer', { step: step + 1, question_id: q.id, answer: Array.isArray(v) ? v.join('+') : v });
      step++;
      if (step >= flow().length) { editing = false; finish(); }
      else drawQuestion();
      root.scrollIntoView({ block: 'start' });
    }

    function savedList() { try { var v = JSON.parse(localStorage.getItem('cs:favorites') || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; } }
    function paintSaved() {
      var l = savedList().map(function (x) { return x.indexOf(':') === -1 ? 'p:' + x : x; });
      Array.prototype.forEach.call(root.querySelectorAll('[data-cs-diag-save]'), function (b) {
        var on = l.indexOf('p:' + b.getAttribute('data-cs-diag-save')) >= 0;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.textContent = on ? '保存しました' : '保存する';
      });
    }

    root.addEventListener('click', function (e) {
      var t = e.target;
      var opt = t.closest('.cs-diag__opt:not(.cs-diag__opt--multi)');
      if (opt) { answer(flow()[step], opt.getAttribute('data-v')); return; }
      var mopt = t.closest('.cs-diag__opt--multi');
      if (mopt) {
        var v = mopt.getAttribute('data-mv'), i = multiSel.indexOf(v), mq = flow()[step];
        if (i >= 0) multiSel.splice(i, 1); else multiSel.push(v);
        // 選べる数に上限がある質問（乗り方は2つまで）は、いちばん先に選んだものを外す
        if (mq.max && multiSel.length > mq.max) {
          var drop = multiSel.shift();
          var db = root.querySelector('[data-mv="' + drop + '"]'); if (db) db.setAttribute('aria-pressed', 'false');
        }
        mopt.setAttribute('aria-pressed', i < 0 ? 'true' : 'false');
        var nb = root.querySelector('[data-cs-diag-next]'); if (nb) nb.textContent = multiSel.length || mq.max ? '次へ' : '当てはまるものはない';
        var tmp = {}; for (var k in answers) if (Object.prototype.hasOwnProperty.call(answers, k)) tmp[k] = answers[k];
        tmp[mq.id] = multiSel.slice();
        refreshPeek(tmp);
        return;
      }
      if (t.closest('[data-cs-diag-next]')) { answer(flow()[step], multiSel.slice()); return; }
      if (t.closest('[data-cs-diag-back]')) { step = Math.max(0, step - 1); drawQuestion(); return; }
      if (t.closest('[data-cs-diag-result]')) { editing = false; finish(); root.scrollIntoView({ block: 'start' }); return; }
      if (t.closest('[data-cs-diag-edit]')) { editing = true; step = 0; drawQuestion(); root.scrollIntoView({ block: 'start' }); return; }
      if (t.closest('[data-cs-diag-restart]')) {
        answers = {}; step = 0; editing = false; lastTop = {}; lastN = null; prevTop = {}; prevN = null;
        try { history.replaceState(null, '', location.pathname); } catch (err) {}
        drawQuestion(); root.scrollIntoView({ block: 'start' }); return;
      }
      if (t.closest('[data-cs-diag-share]')) {
        var b = t.closest('[data-cs-diag-share]');
        try { navigator.clipboard.writeText(location.href).then(function () { b.textContent = 'アドレスをコピーしました'; }); } catch (err) { b.textContent = location.href; }
        track('cs_diagnosis_share', {}); return;
      }
      var sv = t.closest('[data-cs-diag-save]');
      if (sv) {
        var h = sv.getAttribute('data-cs-diag-save'), id = 'p:' + h;
        var l = savedList(), norm = l.map(function (x) { return x.indexOf(':') === -1 ? 'p:' + x : x; });
        var k = norm.indexOf(id);
        if (k === -1) l.push(id); else l.splice(k, 1);
        try {
          localStorage.setItem('cs:favorites', JSON.stringify(l));
          var meta = JSON.parse(localStorage.getItem('cs:pmeta') || '{}');
          meta[id] = { t: sv.getAttribute('data-t') || '', u: '/products/' + h, i: sv.getAttribute('data-i') || '', p: sv.getAttribute('data-p') || '', s: sv.getAttribute('data-s') || '' };
          localStorage.setItem('cs:pmeta', JSON.stringify(meta));
        } catch (err) {}
        document.dispatchEvent(new CustomEvent('cs:favchange'));
        paintSaved();
        track('cs_diagnosis_save', { handle: h }); return;
      }
      if (t.closest('[data-cs-diag-geo]')) {
        var statusEl = root.querySelector('[data-cs-diag-geostatus]');
        if (!navigator.geolocation) { if (statusEl) statusEl.textContent = 'この端末では現在地を使えません'; return; }
        if (statusEl) statusEl.textContent = '現在地を確かめています…';
        navigator.geolocation.getCurrentPosition(function (pos) {
          try { localStorage.setItem(GEO_KEY, JSON.stringify({ lat: pos.coords.latitude, lng: pos.coords.longitude })); } catch (err) {}
          track('cs_diagnosis_geo', { granted: true }); finish(true);
        }, function () {
          if (statusEl) statusEl.textContent = '現在地が分かりませんでした。結果はこのままご覧いただけます';
          track('cs_diagnosis_geo', { granted: false });
        }, { timeout: 8000, maximumAge: 600000 });
        return;
      }
      var link = t.closest('a[href]');
      if (link && root.contains(link)) {
        var href = link.getAttribute('href') || '';
        track('cs_diagnosis_click', { destination: href.indexOf('/products/') === 0 ? 'product' : href.indexOf('/pages/store') === 0 ? 'store' : href.charAt(0) === '#' ? 'anchor' : 'other', href: href });
      }
    });

    root.innerHTML = '<p class="cs-diag__loading">準備しています…</p>';
    var textUrl = root.getAttribute('data-cs-diagnosis-text');
    Promise.all([
      fetch(root.getAttribute('data-cs-diagnosis')).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); }),
      textUrl ? fetch(textUrl).then(function (r) { return r.ok ? r.json() : {}; }).catch(function () { return {}; }) : Promise.resolve({}),
    ]).then(function (res) {
      data = res[0]; text = res[1] || {};
      if (!data || !(data.products || []).length) throw new Error('empty');
      var m = /[#&]d=([^&]+)/.exec(location.hash || '');
      var restored = m ? decode(decodeURIComponent(m[1])) : null;
      if (restored) { answers = restored; finish(true); track('cs_diagnosis_restore', {}); }
      else drawQuestion();
    }).catch(function () {
      root.innerHTML = '<p class="cs-diag__p">ただいま診断を使えません。<a href="/collections/all">自転車の一覧</a>から絞り込むか、<a href="/pages/stores">お近くの店舗</a>でご相談ください。</p>';
    });
  });
})(typeof window !== 'undefined' ? window : this);
